/* V95 — INKSOFT-TAGGED PE FEATURED PRODUCTS + PE PRODUCT MENU SEARCH */
/* V93 — DEDICATED PE PRODUCT MENU / NO REGULAR CATALOG DEPENDENCY */
(function(){
"use strict";
var roots=document.querySelectorAll("[data-ua-pe-program]");
if(!roots.length)return;

function s(v){return String(v==null?"":v).trim()}
function arr(v){return Array.isArray(v)?v:[]}
function esc(v){return s(v).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\"/g,"&quot;").replace(/'/g,"&#039;")}
function uniq(items,keyFn){var seen=new Set();return items.filter(function(item){var k=s(keyFn(item));if(!k||seen.has(k))return false;seen.add(k);return true})}
function get(obj,path){return s(String(path||"").split('.').reduce(function(acc,key){return acc&&acc[key]!=null?acc[key]:null},obj))}
function firstNonEmpty(list){for(var i=0;i<list.length;i++){var v=s(list[i]);if(v)return v}return ""}

var PE_MATRIX=null;
var PE_MATRIX_BY_ID=new Map();
var PE_MATRIX_BY_TITLE=new Map();
var PE_MATRIX_APPAREL=[];
var PE_PRODUCTS_BY_ID=new Map();

function normalizeMatrixLookupText(value){
  return s(value).toLowerCase().replace(/&amp;/g,"&").replace(/[^a-z0-9]+/g," ").replace(/\s+/g," ").trim();
}
function designLookupTitles(d){
  return [d&&d.title,d&&d.name,d&&d.publicTitle,d&&d.public_title,d&&d.artworkTitle,d&&d.artwork_title,d&&d.slug]
    .filter(Boolean).map(normalizeMatrixLookupText).filter(Boolean);
}
function matrixLookupTitles(a){
  return [a&&a.publicTitle,a&&a.public_title,a&&a.artworkTitle,a&&a.artwork_title,a&&a.title,a&&a.name,a&&a.slug]
    .filter(Boolean).map(normalizeMatrixLookupText).filter(Boolean);
}
function deriveMatrixAssetUrl(){
  var scripts=Array.from(document.scripts||[]);
  var canonical=scripts.find(function(el){return /design-inspiration\.js(?:\?|$)/i.test(s(el.src))});
  var current=document.currentScript||scripts.find(function(el){return /unisource-pe-program-showcase\.js(?:\?|$)/i.test(s(el.src))});
  var src=s((canonical||current)&& (canonical||current).src);
  if(!src)return "";
  try{
    var u=new URL(src,location.href);
    if(/design-inspiration\.js$/i.test(u.pathname)){
      u.pathname=u.pathname.replace(/design-inspiration\.js$/i,"design-inspiration-matrix.json");
    }else{
      u.pathname=u.pathname.replace(/unisource-pe-program-showcase\.js$/i,"design-inspiration-matrix.json");
    }
    u.searchParams.set("_pe_matrix_v",String(Date.now()));
    return u.toString();
  }catch(_e){return ""}
}
function normalizeMatrixApparelRecord(record){
  record=recordObject(record);
  var mockups=recordObject(record.mockups);
  var productId=s(record.productId),styleId=s(record.styleId),colorName=s(record.colorName);
  if(!productId||!styleId)return null;
  return {
    key:s(record.key)||[record.brand||"Apparel",record.manufacturerSku||record.productSku||productId,colorName||styleId].filter(Boolean).join("-"),
    category:s(record.apparelType||record.category||"Apparel"),
    type:s(record.apparelType||record.type||"Apparel"),
    brand:s(record.brand),
    manufacturerSku:s(record.manufacturerSku||record.mfgSku),
    mfgSku:s(record.manufacturerSku||record.mfgSku),
    productSku:s(record.productSku),
    productId:productId,
    styleId:styleId,
    colorName:colorName,
    colorFamily:s(record.curatedColorFamily||record.colorFamily||colorName),
    productName:s(record.productName),
    front:s(mockups.Front||record.front),
    frontImageUrl:s(mockups.Front||record.front),
    back:s(mockups.Back||record.back),
    left:s(mockups.Left||record.left),
    right:s(mockups.Right||record.right),
    sideMapping:record.sideMapping||null
  };
}
function buildMatrixIndex(matrix){
  PE_MATRIX=matrix&&typeof matrix==="object"?matrix:null;
  PE_MATRIX_BY_ID=new Map();
  PE_MATRIX_BY_TITLE=new Map();
  PE_MATRIX_APPAREL=[];
  if(!PE_MATRIX)return;
  arr(PE_MATRIX.artworks).forEach(function(a){
    var id=s(a&&(a.designId||a.inksoftDesignId||a.inksoft_design_id));
    if(id)PE_MATRIX_BY_ID.set(id,a);
    matrixLookupTitles(a).forEach(function(k){if(k&&!PE_MATRIX_BY_TITLE.has(k))PE_MATRIX_BY_TITLE.set(k,a)});
  });
  PE_MATRIX_APPAREL=arr(PE_MATRIX.curatedApparel).map(normalizeMatrixApparelRecord).filter(Boolean);
}
async function loadDesignMatrix(){
  var url=deriveMatrixAssetUrl();
  if(!url){console.warn("[PE Program] Design matrix URL unavailable.");return null}
  try{
    var matrix=await request(url);
    buildMatrixIndex(matrix);
    console.info("[PE Program] Design matrix loaded",{artworks:PE_MATRIX_BY_ID.size,curatedApparel:PE_MATRIX_APPAREL.length});
    return matrix;
  }catch(e){
    console.warn("[PE Program] Design matrix could not be loaded.",e);
    buildMatrixIndex(null);
    return null;
  }
}
function extractDesignId(d){
  var direct=s(d&&(d.inksoftDesignId||d.inksoft_design_id||d.designId));
  if(direct)return direct;
  var sources=[d&&d.id,d&&d.slug,d&&d.thumbnailUrl,d&&d.previewImageUrl,d&&d.imageUrl];
  for(var i=0;i<sources.length;i++){
    var v=s(sources[i]),m=v.match(/DI-(\d+)/i)||v.match(/designs\/(\d+)\./i)||v.match(/2959-(\d+)/i)||v.match(/-(\d{6,})$/i);
    if(m&&m[1])return m[1];
  }
  return "";
}
function matrixArtworkFor(d){
  var id=extractDesignId(d);
  if(id&&PE_MATRIX_BY_ID.has(id))return PE_MATRIX_BY_ID.get(id);
  var direct=s(d&&(d.inksoftDesignId||d.inksoft_design_id||d.designId||d.id));
  if(direct&&PE_MATRIX_BY_ID.has(direct))return PE_MATRIX_BY_ID.get(direct);
  var keys=designLookupTitles(d);
  for(var i=0;i<keys.length;i++){if(PE_MATRIX_BY_TITLE.has(keys[i]))return PE_MATRIX_BY_TITLE.get(keys[i])}
  return null;
}
function matrixSideFor(d,side){
  var artwork=matrixArtworkFor(d),key=normalizeSideName(side);
  var r=artwork&&artwork.sides&&artwork.sides[key];
  if(!r)return null;
  return {
    side:key,
    displaySide:Boolean(r.displaySide),
    placementLabel:s(r.placementLabel||r.placementPreset||key),
    placementPreset:s(r.placementPreset),
    artworkUrlOverride:s(r.artworkUrlOverride),
    artworkPositionGrid:r.artworkPositionGrid||r.artworkPositionModal||r.position||r.placementOverride||{},
    apparelPositionGrid:r.apparelPositionGrid||r.apparelPositionModal||r.apparelPosition||r.mockupPosition||r.garmentPosition||{}
  };
}

function request(url){
  return fetch(url,{method:"GET",headers:{Accept:"application/json"},credentials:new URL(url,location.origin).origin===location.origin?"same-origin":"omit"})
    .then(function(r){if(!r.ok)throw new Error("HTTP "+r.status);return r.json()});
}
async function withFallback(primary,fallback){
  try{return await request(primary)}catch(e){if(!fallback||fallback===primary)throw e;return request(fallback)}
}
function categories(payload){return arr(payload&& (payload.categories||payload.data||payload.items||payload.results))}
function children(c){return arr(c&&(c.children||c.Children||c.subCategories||c.SubCategories))}
function cid(c){return s(c&&(c.id!=null?c.id:(c.ID!=null?c.ID:(c.categoryId!=null?c.categoryId:c.CategoryId))))}
function cname(c){return s(c&&(c.name||c.Name||c.label||c.CategoryName))}
function flatten(list){var out=[];(function walk(nodes){arr(nodes).forEach(function(n){if(!n)return;out.push(n);walk(children(n))})})(list);return out}
function products(payload){if(Array.isArray(payload))return payload;return arr(payload&&(payload.products||payload.items||payload.data||payload.results))}
function pid(p){return s(p&&(p.id||p.productId||p.ProductId||p.ID))}
function pname(p){return s(p&&(p.name||p.productName||p.Name||"PE Uniform"))}
function pbrand(p){return s(p&&(p.brand||p.manufacturer||p.Brand||p.Manufacturer))}
function pcolors(p){return arr(p&&(p.colors||p.colorways||p.styles))}
function cname2(c){return s(c&&(c.name||c.colorName||c.label||c.Name))}
function styleId(c){return s(c&&(c.styleId||c.StyleId||c.id||c.Id))}
function chex(c,n){return s(c&&(n===2?(c.hex2||c.htmlColor2||c.Hex2):(c.hex1||c.htmlColor1||c.hex||c.HtmlColor1||c.Hex1)))}
function cimg(c){return s(c&&(c.imageUrl||c.thumbnailUrl||c.ImageUrl||c.ThumbnailUrl))}
function initialColor(p){
  var cs=pcolors(p),sid=s(p&&(p.defaultStyleId||p.DefaultStyleId||p.styleId)),dc=s(p&&(p.defaultColor||p.DefaultColor||p.colorName)).toLowerCase(),m;
  if(sid)m=cs.find(function(c){return styleId(c)===sid});
  if(!m&&dc)m=cs.find(function(c){return cname2(c).toLowerCase()===dc});
  return m||cs[0]||null;
}
function pimg(p,c){return cimg(c)||s(p&&(p.thumbnailUrl||p.imageUrl||p.primaryImage||p.ImageUrl))}
function numVal(){
  for(var i=0;i<arguments.length;i++){
    var v=arguments[i];
    if(v===null||v===undefined||v==='')continue;
    if(typeof v==='number'&&Number.isFinite(v))return v;
    var n=Number(String(v).replace(/[^0-9.-]+/g,''));
    if(Number.isFinite(n))return n;
  }
  return 0;
}
function punitPrice(p,c){
  return numVal(
    c&&(c.price||c.unitPrice||c.basePrice||c.Price||c.UnitPrice),
    p&&(p.price||p.basePrice||p.unitPrice||p.startingPrice||p.minimumPrice||p.Price||p.BasePrice||p.UnitPrice)
  );
}
function pminQty(p,c){
  var qty=numVal(
    c&&(c.minimumQuantity||c.minQty||c.MinimumQuantity),
    p&&(p.minimumQuantity||p.minQty||p.minimumOrderQuantity||p.MinimumQuantity)
  );
  return Math.max(1,Math.round(qty||1));
}
function peFlattenTags(value,out){
  out=out||[];
  if(value==null)return out;
  if(Array.isArray(value)){value.forEach(function(v){peFlattenTags(v,out)});return out;}
  if(typeof value==="object"){
    ["name","Name","label","Label","value","Value","tag","Tag"].some(function(k){if(value[k]!=null){peFlattenTags(value[k],out);return true}return false});
    return out;
  }
  String(value).split(/[;,|]/).forEach(function(v){v=s(v);if(v)out.push(v)});
  return out;
}
function peProductTags(p){
  var out=[];
  [p&&p.tags,p&&p.Tags,p&&p.tag,p&&p.Tag,p&&p.storeSearchTags,p&&p.StoreSearchTags,p&&p.searchTags,p&&p.SearchTags,p&&p.productTags,p&&p.ProductTags,p&&p.webStoreTags,p&&p.WebStoreTags,p&&p.keywords,p&&p.Keywords,p&&p.raw&&p.raw.Tags,p&&p.raw&&p.raw.StoreSearchTags,p&&p.raw&&p.raw.Keywords].forEach(function(v){peFlattenTags(v,out)});
  return Array.from(new Set(out));
}
function peSizeRows(style){
  var candidates=[];
  var seenObjects=new Set();

  function pushRow(item){
    if(item==null)return;
    if(typeof item==="string"){
      var txt=s(item);
      if(txt)candidates.push({id:0,label:txt,raw:item});
      return;
    }
    if(typeof item!=="object")return;

    var label=s(
      item.name||item.Name||item.label||item.Label||item.size||item.Size||
      item.displayName||item.DisplayName||item.sizeName||item.SizeName||
      item.productStyleSizeName||item.ProductStyleSizeName||
      item.value||item.Value
    );
    var id=numVal(
      item.productStyleSizeId||item.ProductStyleSizeId||
      item.styleSizeId||item.StyleSizeId||
      item.sizeId||item.SizeId||
      item.id||item.ID||item.Id
    );
    if(label)candidates.push({id:id,label:label,raw:item});
  }

  function addList(list){
    arr(list).forEach(pushRow);
  }

  function walk(node,depth){
    if(node==null||depth>9)return;
    if(typeof node!=="object")return;
    if(seenObjects.has(node))return;
    seenObjects.add(node);

    if(Array.isArray(node)){
      node.forEach(function(v){
        pushRow(v);
        walk(v,depth+1);
      });
      return;
    }

    /* Capture a size object even when it is not inside a conventional Sizes array. */
    if(
      node.productStyleSizeId!=null||node.ProductStyleSizeId!=null||
      node.styleSizeId!=null||node.StyleSizeId!=null||
      node.sizeId!=null||node.SizeId!=null
    )pushRow(node);

    [
      "sizes","Sizes","productStyleSizes","ProductStyleSizes",
      "availableSizes","AvailableSizes","sizeOptions","SizeOptions",
      "productSizes","ProductSizes","styleSizes","StyleSizes"
    ].forEach(function(k){if(node[k]!=null)addList(node[k]);});

    /* Product-detail payloads have changed shape over time. Walk every nested object
       so we do not silently lose ProductStyleSizeId when InkSoft moves it. */
    Object.keys(node).forEach(function(k){
      var v=node[k];
      if(v&&typeof v==="object")walk(v,depth+1);
    });
  }

  walk(style,0);

  /* One row per visible size label. Prefer a real InkSoft ProductStyleSizeId over
     an earlier label-only row from a summary payload. */
  var byLabel=new Map();
  candidates.forEach(function(row){
    var key=s(row.label).toLowerCase();
    if(!key)return;
    var existing=byLabel.get(key);
    if(!existing||(Number(row.id)>0&&!(Number(existing.id)>0)))byLabel.set(key,row);
  });
  return Array.from(byLabel.values());
}
function peProductMinimumQuantity(p){
  return Math.max(1,Math.round(numVal(p&&(p.productMinimumQuantity||p.ProductMinimumQuantity||p.minimumItemQuantity||p.MinimumItemQuantity||p.minimumDesignQuantity||p.MinimumDesignQuantity),p&&p.minimums&&(p.minimums.productMinimumQuantity||p.minimums.minimumItemQuantity),p&&p.minimumQuantity,p&&p.minQty)||1));
}
function peInksoftMinimumQuantity(payload,style){
  var candidates=[];
  var seen=new Set();

  function add(value){
    var n=numVal(value);
    if(n>0)candidates.push(n);
  }

  function collect(node,depth){
    if(node==null||depth>10)return;
    if(Array.isArray(node)){node.forEach(function(v){collect(v,depth+1)});return;}
    if(typeof node!=="object")return;
    if(seen.has(node))return;
    seen.add(node);

    [
      "productMinimumQuantity","ProductMinimumQuantity",
      "minimumItemQuantity","MinimumItemQuantity",
      "minimumDesignQuantity","MinimumDesignQuantity",
      "minimumOrderQuantity","MinimumOrderQuantity",
      "minimumQuantity","MinimumQuantity",
      "minQty","MinQty",
      "perOrder","PerOrder",
      "minimumPerOrder","MinimumPerOrder",
      "orderMinimum","OrderMinimum",
      "minOrderQuantity","MinOrderQuantity",
      "minimumOrderQty","MinimumOrderQty"
    ].forEach(function(k){if(node[k]!=null)add(node[k]);});

    /* InkSoft's admin calls this setting "Per Order". Some API/cache shapes expose
       it under differently named minimum/order keys, so recognize those generically. */
    Object.keys(node).forEach(function(k){
      var v=node[k];
      var nk=String(k).toLowerCase().replace(/[^a-z0-9]/g,"");
      if(v!=null&&typeof v!=="object"){
        if(
          (nk.indexOf("minimum")>=0||nk.indexOf("min")===0||nk.indexOf("minimums")>=0)&&
          (nk.indexOf("order")>=0||nk.indexOf("quantity")>=0||nk.indexOf("qty")>=0||nk.indexOf("item")>=0||nk.indexOf("product")>=0)
        )add(v);
        if(nk==="perorder")add(v);
      }
      if(v&&typeof v==="object")collect(v,depth+1);
    });
  }

  collect(style,0);
  collect(payload,0);
  if(!candidates.length)return 1;

  /* Use the highest positive product-level minimum we can identify. This prevents
     placeholder/default values such as 1 from masking the actual InkSoft Per Order
     setting (e.g. 72). */
  return Math.max(1,Math.round(Math.max.apply(Math,candidates)));
}
function peCurrentStyleForProduct(p,styleIdValue){
  var colors=pcolors(p);
  var sid=s(styleIdValue);
  return colors.find(function(c){return styleId(c)===sid})||initialColor(p)||colors[0]||null;
}
function peFindStyleInDetail(payload,styleIdValue){
  var target=s(styleIdValue);
  var visited=new Set();
  var fallback=null;
  function walk(node,depth){
    if(!node||depth>7||typeof node!=="object")return null;
    if(visited.has(node))return null;
    visited.add(node);
    if(!Array.isArray(node)){
      var nodeId=s(node.id||node.ID||node.Id||node.styleId||node.StyleId||node.productStyleId||node.ProductStyleId);
      var sizes=peSizeRows(node);
      if(sizes.length){
        if(!fallback)fallback=node;
        if(target&&nodeId===target)return node;
      }
    }
    if(Array.isArray(node)){
      for(var i=0;i<node.length;i++){var hit=walk(node[i],depth+1);if(hit)return hit;}
    }else{
      var keys=["data","Data","product","Product","styles","Styles","productStyles","ProductStyles","colors","Colors","variants","Variants","raw","Raw"];
      for(var j=0;j<keys.length;j++){if(node[keys[j]]!=null){var hit2=walk(node[keys[j]],depth+1);if(hit2)return hit2;}}
    }
    return null;
  }
  return walk(payload,0)||fallback;
}
async function peLoadQuickPriceSizesFromDetail(rootEl,modal){
  var data=modal&&modal._pePreviewData||{};
  if(!data.productId||data.quickPriceDetailLoaded)return;
  data.quickPriceDetailLoaded=true;
  modal._pePreviewData=data;
  var box=modal.querySelector("[data-pe-product-lightbox-qp-sizes]");
  if(box)box.innerHTML='<div class="ua-pe-product-lightbox__calc-help">Loading available sizes…</div>';
  try{
    var endpoint=s(rootEl.dataset.productDetailEndpoint)||"https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/product";
    var url=new URL(endpoint,location.origin);
    url.searchParams.set("id",String(data.productId));
    var response=await fetch(url.toString(),{method:"GET",headers:{Accept:"application/json"},credentials:"omit",cache:"no-store"});
    if(!response.ok)throw new Error("Product detail request failed ("+response.status+")");
    var payload=await response.json();
    var style=peFindStyleInDetail(payload,data.styleId);
    var rows=peSizeRows(style||payload);
    data.sizeRows=rows;
    data.productMinimumQuantity=peInksoftMinimumQuantity(payload,style||payload);
    modal._pePreviewData=data;
    peRenderQuickPriceSizes(modal);
    if(!rows.length)peQuickPriceError(modal,"Sizes could not be loaded for this style. Open Product Detail for the full calculator.");
    else peQuickPriceError(modal,"");
  }catch(err){
    console.error("[PE Program] size detail load failed",err);
    peRenderQuickPriceSizes(modal);
    peQuickPriceError(modal,"Unable to load size options. Open Product Detail for the full calculator.");
  }
}
function productUrl(p,c){
  var u=new URL("/pages/product-detail-v2?view=unisource-product-detail-v2",location.origin);
  u.searchParams.set("productId",pid(p));
  var sid=styleId(c)||s(p&&(p.defaultStyleId||p.DefaultStyleId||p.styleId));
  var cn=cname2(c)||s(p&&(p.defaultColor||p.DefaultColor||p.colorName));
  if(sid)u.searchParams.set("styleId",sid);
  if(cn)u.searchParams.set("selectedColor",cn);
  u.searchParams.set("returnUrl","/pages/pe-uniforms");
  return u.pathname+u.search;
}
function swatch(c){
  var h1=chex(c,1)||"#d1d5db",h2=chex(c,2),bg=h2?"linear-gradient(135deg,"+esc(h1)+" 0 50%,"+esc(h2)+" 50% 100%)":h1;
  return '<span class="ua-pe-card__swatch" title="'+esc(cname2(c))+'" style="background:'+bg+'"></span>';
}
function peProductKind(p){
  var text=[pname(p),pbrand(p),s(p&&p.category),s(p&&p.productType),s(p&&p.type)].join(" ").toLowerCase();
  if(/\b(short|shorts)\b/.test(text))return "short";
  if(/\b(pant|pants|sweatpant|sweatpants|jogger|joggers|bottom|bottoms)\b/.test(text))return "bottom";
  return "top";
}
function pePlacementLabel(key){
  return ({
    "full-front":"Full Front",
    "left-chest":"Left Chest",
    "right-chest":"Right Chest",
    "top-left":"Top Left",
    "top-right":"Top Right",
    "full-left-leg":"Full Left Leg",
    "full-right-leg":"Full Right Leg",
    "left-bottom-leg":"Left Bottom Leg",
    "right-bottom-leg":"Right Bottom Leg"
  })[key]||key;
}
function pePlacementKeys(kind){
  if(kind==="short")return ["right-bottom-leg","left-bottom-leg"];
  if(kind==="bottom")return ["top-left","top-right","full-left-leg","full-right-leg"];
  return ["right-chest","left-chest","full-front"];
}
function pePlacementButtons(kind){
  return pePlacementKeys(kind).map(function(key){
    return '<button class="ua-pe-product-preview__placement" type="button" data-pe-preview-placement="'+esc(key)+'">'+esc(pePlacementLabel(key))+'</button>';
  }).join("");
}
function productCard(p){
  var c=initialColor(p),cs=pcolors(p),shown=cs.slice(0,7),more=Math.max(0,cs.length-shown.length),url=productUrl(p,c),img=pimg(p,c);
  var kind=peProductKind(p);
  var originalImg=preferOriginal(img)||img;
  var price=punitPrice(p,c);
  var minQty=pminQty(p,c);
  return '<article class="ua-pe-card ua-pe-card--product" data-pe-product-kind="'+esc(kind)+'" data-pe-product-id="'+esc(pid(p))+'" data-pe-product-style-id="'+esc(styleId(c)||s(p&&(p.defaultStyleId||p.DefaultStyleId||p.styleId)))+'" data-pe-product-color="'+esc(cname2(c)||s(p&&(p.defaultColor||p.DefaultColor||p.colorName)))+'" data-pe-product-url="'+esc(url)+'" data-pe-product-unit-price="'+esc(price)+'" data-pe-product-min-qty="'+esc(minQty)+'" data-pe-product-original-image="'+esc(originalImg)+'">'+
    '<a class="ua-pe-card__image-link ua-pe-card__image-link--previewable" href="'+esc(url)+'" data-pe-product-apparel-original="'+esc(originalImg)+'">'+
      (img?'<img class="ua-pe-card__image" src="'+esc(img)+'" alt="'+esc(pname(p))+'" loading="lazy" decoding="async">':"")+
      '<img class="ua-pe-product-artwork" data-pe-product-artwork alt="" aria-hidden="true">'+
    '</a>'+
    '<div class="ua-pe-card__body">'+
      '<div class="ua-pe-card__kicker">'+esc(pbrand(p)||"PE Uniform")+'</div>'+
      '<h3 class="ua-pe-card__title">'+esc(pname(p))+'</h3>'+
      (cs.length?'<div class="ua-pe-card__swatches">'+shown.map(swatch).join("")+(more?'<span class="ua-pe-card__more">+'+more+' more</span>':"")+'</div>':"")+
      '<div class="ua-pe-product-preview" data-pe-product-preview>'+
        '<button class="ua-pe-product-preview__toggle" type="button" data-pe-preview-toggle aria-expanded="false">Preview Design on Apparel</button>'+
        '<div class="ua-pe-product-preview__panel" data-pe-preview-panel hidden>'+
          '<div class="ua-pe-product-preview__label">Choose Artwork</div>'+
          '<div class="ua-pe-product-preview__artworks" data-pe-preview-artworks></div>'+
          '<div class="ua-pe-product-preview__label ua-pe-product-preview__label--placement">Artwork Position</div>'+
          '<div class="ua-pe-product-preview__placements">'+pePlacementButtons(kind)+'</div>'+
          '<button class="ua-pe-product-preview__remove" type="button" data-pe-preview-remove>Remove Artwork</button>'+
        '</div>'+
      '</div>'+
      '<a class="ua-pe-card__action" href="'+esc(url)+'">Choose Apparel</a>'+
    '</div>'+
  '</article>';
}

function designItems(payload){
  if(Array.isArray(payload))return payload;
  if(Array.isArray(payload&&payload.designs))return payload.designs;
  if(Array.isArray(payload&&payload.items))return payload.items;
  if(Array.isArray(payload&&payload.results))return payload.results;
  if(Array.isArray(payload&&payload.data))return payload.data;
  if(payload&&payload.data&&Array.isArray(payload.data.designs))return payload.data.designs;
  if(payload&&payload.data&&Array.isArray(payload.data.items))return payload.data.items;
  return [];
}
function did(d){return s(d&&(d.designId||d.id||d.inksoftDesignId||d.DesignId))}
function dslug(d){return s(d&&(d.slug||d.publicSlug||did(d)))}
function dtitle(d){return s(d&&(d.title||d.name||d.publicTitle||d.artworkTitle||"PE Design Idea"))}
function dtext(d){
  var vals=[d&&d.segment,d&&d.theme,d&&d.collection,d&&d.activity,d&&d.productGroup,dtitle(d)];
  arr(d&&d.tags).forEach(function(v){vals.push(v)});arr(d&&d.keywords).forEach(function(v){vals.push(v)});
  return vals.map(s).join(" ").toLowerCase().replace(/_/g,"-");
}
function isPE(d){
  var x=dtext(d);
  return /\bpe-uniform\b/.test(x)||/\bphysical education\b/.test(x)||/(^|[\s,;|/-])pe($|[\s,;|/-])/.test(x);
}
function designUrl(d){
  var u=new URL("/pages/design-inspiration-center",location.origin);
  u.searchParams.set("open","visualizer");
  if(dslug(d))u.searchParams.set("slug",dslug(d));else if(did(d))u.searchParams.set("designId",did(d));
  return u.pathname+u.search;
}

/*
  ================================================================
  LOCKED / CRITICAL RENDERING GUARD — PE DESIGN CARD COMPOSITE
  The public Design Inspiration search API does NOT provide one
  flattened "rendered apparel" image. The live Design Inspiration
  grid is a client-side composite of:
    1) apparel/mockup image
    2) artwork image
    3) grid placement values
  Keep this layered renderer aligned with that public record shape.
  Do not replace it with thumbnailUrl/previewUrl as the first choice.
  ================================================================
*/
function recordObject(value){return value&&typeof value==="object"&&!Array.isArray(value)?value:{}}
function numberOr(value,fallback){
  var n=Number(value);
  return Number.isFinite(n)?n:fallback;
}
function firstValue(){
  for(var i=0;i<arguments.length;i++){
    var v=arguments[i];
    if(v!==null&&v!==undefined&&String(v).trim()!=="")return v;
  }
  return "";
}
function normalizeSideName(value){
  var x=s(value).toLowerCase();
  if(x==="back")return "Back";
  if(x==="left"||x==="left sleeve")return "Left";
  if(x==="right"||x==="right sleeve")return "Right";
  return "Front";
}
function designProductId(row){return s(row&&(row.productId||row.inksoftProductId||row.product_id))}
function designStyleId(row){return s(row&&(row.styleId||row.inksoftStyleId||row.productStyleId||row.style_id))}
function designColor(row){return s(row&&(row.colorName||row.color||row.selectedColor||row.defaultColor))}
function designRowSide(row){
  return normalizeSideName(row&&(row.side||row.view||row.placementSide||row.printSide||row.productSide||row.label||"Front"));
}
function safeGarmentUrl(value){
  var url=s(value);
  if(!url)return "";
  var low=url.toLowerCase();
  if(low.indexOf("/jitimage/")>=0||
     low.indexOf("/images/publishers/")>=0||
     low.indexOf("/publishers/")>=0||
     low.indexOf("/designs/")>=0||
     low.indexOf("/rendered/")>=0||
     low.indexOf("/mockups/")>=0||
     low.indexOf("designid=")>=0||
     low.indexOf("inksoftdesignid=")>=0||
     low.indexOf("transparentartworkurl=")>=0||
     low.indexOf("designartworkurl=")>=0)return "";
  return url;
}
function preferOriginal(url){
  var t=s(url);
  return t?t.replace(/\/500\.png(\?[^"'\s]*)?$/i,"/Original.png$1"):"";
}
function garmentCandidates(){
  var seen={},out=[];
  Array.prototype.slice.call(arguments).forEach(function(v){
    var clean=safeGarmentUrl(v);
    if(!clean)return;
    [preferOriginal(clean),clean].forEach(function(u){
      if(u&&!seen[u]){seen[u]=1;out.push(u)}
    });
  });
  return out;
}
function rowImageForSide(row,side){
  row=recordObject(row);side=normalizeSideName(side);
  if(side==="Back")return garmentCandidates(row.backImageUrl,row.backGarmentImageUrl,row.back,row.apparelBackImageUrl)[0]||"";
  if(side==="Left")return garmentCandidates(row.leftImageUrl,row.leftGarmentImageUrl,row.left,row.apparelLeftImageUrl)[0]||"";
  if(side==="Right")return garmentCandidates(row.rightImageUrl,row.rightGarmentImageUrl,row.right,row.apparelRightImageUrl)[0]||"";
  return garmentCandidates(row.frontImageUrl,row.frontGarmentImageUrl,row.front,row.apparelImageUrl,row.imageUrl)[0]||"";
}

/*
  ================================================================
  LOCKED / CRITICAL RENDERING GUARD — V5 EXACT GRID REFERENCE PLANE
  Canonical Design Inspiration cards author Grid apparel/artwork placement
  against a 348 x 372 reference plane. Do NOT normalize apparelScale or
  artworkWidth for this PE landing page. Keep the same reference aspect
  ratio and apply the saved percentages literally.
  ================================================================
*/
function allAdminRows(d){
  var rows=[];
  function add(v){if(v&&typeof v==="object"&&!Array.isArray(v))rows.push(v)}
  [
    d&&d.mockup,d&&d.defaultMockup,d&&d.primaryMockup,
    d&&d.productStyleReference,d&&d.productReference,
    d&&d.apparelReference,d&&d.defaultApparel,d&&d.apparel
  ].forEach(add);

  if(Array.isArray(d&&d.mockups))d.mockups.forEach(add);
  else if(d&&d.mockups&&typeof d.mockups==="object"){
    add(d.mockups.default);add(d.mockups.primary);
    arr(d.mockups.items).forEach(add);arr(d.mockups.records).forEach(add);
  }
  arr(d&&d.productReferences).forEach(add);
  arr(d&&d.apparelReferences).forEach(add);
  return rows;
}
function rowGroupKey(row){
  return [designProductId(row),designStyleId(row),designColor(row).toLowerCase()].join("|");
}
function chooseDefaultGroup(d){
  var rows=allAdminRows(d);
  if(!rows.length)return [];

  var wantedKey=s(d&&d.defaultApparelKey);
  var wantedProduct=s(d&&(d.defaultProductId||d.default_product_id));
  var wantedStyle=s(d&&(d.defaultStyleId||d.default_style_id));
  var wantedColor=s(d&&(d.defaultColor||d.default_color)).toLowerCase();

  var groups={},order=[];
  rows.forEach(function(row){
    var key=rowGroupKey(row);
    if(!groups[key]){groups[key]=[];order.push(key)}
    groups[key].push(row);
  });

  var chosen=order.find(function(key){return wantedKey&&key===wantedKey});
  if(!chosen)chosen=order.find(function(key){
    var r=groups[key][0]||{};
    return wantedProduct&&wantedStyle&&
      designProductId(r)===wantedProduct&&designStyleId(r)===wantedStyle&&
      (!wantedColor||designColor(r).toLowerCase()===wantedColor);
  });
  if(!chosen)chosen=order.find(function(key){
    return groups[key].some(function(r){return designRowSide(r)==="Front"&&Boolean(rowImageForSide(r,"Front"))});
  });
  if(!chosen)chosen=order[0];
  return groups[chosen]||[];
}
function exactMatrixApparelMatch(row){
  row=recordObject(row);
  var productId=designProductId(row),styleId=designStyleId(row),color=normalizeMatrixLookupText(designColor(row));
  if(!productId||!styleId)return null;
  return PE_MATRIX_APPAREL.find(function(x){
    if(s(x.productId)!==productId||s(x.styleId)!==styleId)return false;
    if(!color)return true;
    return normalizeMatrixLookupText(x.colorName||x.colorFamily)===color;
  })||null;
}
function chooseFrontRow(d){
  var group=chooseDefaultGroup(d);
  var row=group.find(function(r){return designRowSide(r)==="Front"&&Boolean(rowImageForSide(r,"Front"))})||
          group.find(function(r){return Boolean(rowImageForSide(r,"Front"))})||
          group[0]||null;

  var ma=matrixArtworkFor(d);
  var desiredProduct=s((ma&&ma.defaultApparel&&ma.defaultApparel.productId)||(d&&(d.defaultProductId||d.default_product_id)));
  var desiredStyle=s((ma&&ma.defaultApparel&&ma.defaultApparel.styleId)||(d&&(d.defaultStyleId||d.default_style_id)));
  var desiredColor=normalizeMatrixLookupText((ma&&ma.defaultApparel&&ma.defaultApparel.color)||(d&&(d.defaultColor||d.default_color)));

  if(desiredProduct&&desiredStyle){
    var all=allAdminRows(d);
    var better=all.find(function(r){
      return designRowSide(r)==="Front"&&
        designProductId(r)===desiredProduct&&designStyleId(r)===desiredStyle&&
        (!desiredColor||normalizeMatrixLookupText(designColor(r))===desiredColor);
    })||all.find(function(r){
      return designProductId(r)===desiredProduct&&designStyleId(r)===desiredStyle&&
        (!desiredColor||normalizeMatrixLookupText(designColor(r))===desiredColor);
    });
    if(better)row=better;
  }
  return row;
}
function publisherArtworkUrl(d){
  var id=extractDesignId(d)||did(d);
  return id?"https://cdn.inksoft.com/images/publishers/2959/designs/"+encodeURIComponent(id)+".front.480.png":"";
}
function frontArtworkUrl(d,row){
  var ms=matrixSideFor(d,"Front");
  var views=arr(d&&d.artworkViews);
  var frontView=views.find(function(v){return normalizeSideName(v&&(v.side||v.view||v.label))==="Front"});
  return firstNonEmpty([
    ms&&ms.artworkUrlOverride,
    frontView&&(frontView.artworkUrl||frontView.imageUrl||frontView.url),
    row&&(row.artworkImageUrl||row.frontArtworkUrl||row.front_artwork_url||row.transparentArtworkUrl),
    d&&(d.frontArtworkUrl||d.front_artwork_url),
    publisherArtworkUrl(d),
    d&&(d.thumbnailUrl||d.previewImageUrl||d.imageUrl||d.previewUrl)
  ]);
}
function normalizeSkuPlacementKey(value){return s(value).replace(/\s+/g," ")}
function placementSkuCandidateKeys(row){
  row=recordObject(row);
  var support=exactMatrixApparelMatch(row)||{};
  var productId=normalizeSkuPlacementKey(designProductId(row)||support.productId);
  var styleId=normalizeSkuPlacementKey(designStyleId(row)||support.styleId);
  var sku=normalizeSkuPlacementKey(
    row.manufacturerSku||row.mfgSku||row.sku||row.productSku||
    support.manufacturerSku||support.mfgSku||support.productSku||""
  );
  var keys=[row.placementSkuKey,[productId,styleId,sku].join("|"),[productId,styleId,""].join("|"),[productId,"",sku].join("|"),["",styleId,sku].join("|")];
  var seen={};
  return keys.filter(function(key){key=s(key);if(!key||!key.replace(/\|/g,"").trim()||seen[key])return false;seen[key]=1;return true});
}
function visualGridPlacement(entry){
  entry=recordObject(entry);
  if(!Object.keys(entry).length)return null;
  var sides=recordObject(entry.sides);
  var se=recordObject(sides.Front||sides.front||sides.FRONT);
  if(Object.keys(se).length)return recordObject(se.grid||se.gridPlacement);
  return recordObject(entry.grid||entry.gridPlacement);
}
function exactAdminGridPlacement(d,row){
  var map=recordObject(d&&d.placementBySku),keys=placementSkuCandidateKeys(row);
  for(var i=0;i<keys.length;i++){
    if(map[keys[i]]){
      var p=visualGridPlacement(map[keys[i]]);
      if(p&&Object.keys(p).length)return p;
    }
  }
  /* Canonical secondary source: row-level placement on current design record. */
  var rp=visualGridPlacement(row);
  return rp&&Object.keys(rp).length?rp:null;
}
function hasPos(v){return v!==null&&v!==undefined&&v!==""}
function firstPos(){
  for(var i=0;i<arguments.length;i++){if(hasPos(arguments[i]))return arguments[i]}
  return undefined;
}
function normalizeArtworkPos(src){
  src=recordObject(src);
  return {
    leftPercent:firstPos(src.leftPercent,src.artworkXPercent),
    topPercent:firstPos(src.topPercent,src.artworkYPercent),
    artworkWidthPercent:firstPos(src.artworkWidthPercent,src.widthPercent),
    translateXPercent:firstPos(src.translateXPercent,src.translateX,-50),
    translateYPercent:firstPos(src.translateYPercent,src.translateY,-50),
    rotationDeg:firstPos(src.rotationDeg,0)
  };
}
function normalizeApparelPos(src){
  src=recordObject(src);
  return {
    leftPercent:firstPos(src.leftPercent,src.apparelLeftPercent,src.mockupLeftPercent),
    topPercent:firstPos(src.topPercent,src.apparelTopPercent,src.mockupTopPercent),
    widthPercent:firstPos(src.widthPercent,src.apparelWidthPercent,src.mockupWidthPercent),
    heightPercent:firstPos(src.heightPercent,src.apparelHeightPercent,src.mockupHeightPercent),
    translateXPercent:firstPos(src.translateXPercent,src.translateX),
    translateYPercent:firstPos(src.translateYPercent,src.translateY),
    scale:firstPos(src.scale),
    rotationDeg:firstPos(src.rotationDeg,0)
  };
}
function mergePos(){
  var result={};
  Array.prototype.slice.call(arguments).forEach(function(src){
    if(!src)return;
    Object.keys(src).forEach(function(k){if(!hasPos(result[k])&&hasPos(src[k]))result[k]=src[k]});
  });
  return result;
}
function matrixFallback(name){return recordObject(PE_MATRIX&&PE_MATRIX.fallbackPresets&&PE_MATRIX.fallbackPresets[name])}
function matrixFallbackBySide(name,side){
  var p=matrixFallback(name),key=normalizeSideName(side);
  return recordObject(p[key]||p[key.toLowerCase()]);
}
function matrixPlacementPreset(name){
  return recordObject(PE_MATRIX&&PE_MATRIX.placementPresets&&PE_MATRIX.placementPresets[s(name)]);
}
function matrixApparelPreset(row,side){
  var presets=recordObject(PE_MATRIX&&PE_MATRIX.apparelPositionPresets);
  var support=exactMatrixApparelMatch(row)||{};
  var keys=[row&&row.category,row&&row.type,row&&row.manufacturerSku,row&&row.mfgSku,row&&row.productSku,designProductId(row),support.category,support.type,support.mfgSku,support.productSku,support.productId,support.key].map(s).filter(Boolean);
  var sideKey=normalizeSideName(side);
  for(var i=0;i<keys.length;i++){
    var entry=recordObject(presets[keys[i]]);
    if(!Object.keys(entry).length)continue;
    var se=recordObject(entry[sideKey]||entry.Default||entry.default||entry);
    var resolved=se.apparelPositionGridMultiSide||se.apparelPositionGrid||se.apparelPositionModal||se;
    if(resolved&&typeof resolved==="object")return normalizeApparelPos(resolved);
  }
  return {};
}
function adminArtworkPos(p){
  p=recordObject(p);
  if(!Object.keys(p).length)return null;
  return {
    leftPercent:firstPos(p.artworkX,p.artworkXPct,p.xPct,p.leftPercent),
    topPercent:firstPos(p.artworkY,p.artworkYPct,p.yPct,p.topPercent),
    artworkWidthPercent:firstPos(p.artworkWidth,p.artworkWidthPct,p.scalePct,p.widthPercent),
    translateXPercent:firstPos(p.translateXPercent,p.translateX,-50),
    translateYPercent:firstPos(p.translateYPercent,p.translateY,-50),
    rotationDeg:firstPos(p.artworkRotation,p.artworkRotationDeg,p.rotationDeg,0)
  };
}
function adminApparelPos(p){
  p=recordObject(p);
  if(!Object.keys(p).length)return null;
  return {
    leftPercent:firstPos(p.apparelX,p.apparelXPct,p.leftPercent),
    topPercent:firstPos(p.apparelY,p.apparelYPct,p.topPercent),
    widthPercent:firstPos(p.apparelScale,p.apparelScalePct,p.apparelWidthPercent,p.widthPercent),
    heightPercent:firstPos(p.apparelHeight,p.apparelHeightPct,p.heightPercent),
    translateXPercent:firstPos(p.translateXPercent,p.translateX,-50),
    translateYPercent:firstPos(p.translateYPercent,p.translateY,-50),
    rotationDeg:firstPos(p.apparelRotation,p.apparelRotationDeg,p.rotationDeg,0)
  };
}
function resolveApparelPosition(d,row){
  var admin=adminApparelPos(exactAdminGridPlacement(d,row));
  if(admin)return admin;
  var ms=matrixSideFor(d,"Front");
  return mergePos(
    normalizeApparelPos(ms&&ms.apparelPositionGrid),
    matrixApparelPreset(row,"Front"),
    normalizeApparelPos(matrixFallbackBySide("defaultApparelPositionGridBySide","Front")),
    normalizeApparelPos(matrixFallback("defaultApparelPositionGrid"))
  );
}
function resolveArtworkPosition(d,row){
  var admin=adminArtworkPos(exactAdminGridPlacement(d,row));
  if(admin)return admin;
  var ms=matrixSideFor(d,"Front");
  var preset=matrixPlacementPreset((ms&&(ms.placementPreset||ms.placementLabel))||"Full Front");
  return mergePos(
    normalizeArtworkPos(ms&&ms.artworkPositionGrid),
    normalizeArtworkPos(preset.artworkPositionGrid||preset.artworkPositionModal||preset),
    normalizeArtworkPos(matrixFallbackBySide("defaultArtworkPositionGridBySide","Front")),
    normalizeArtworkPos(matrixFallback("defaultArtworkPositionGrid"))
  );
}
function apparelImageFor(d,row){
  var support=exactMatrixApparelMatch(row)||{};
  return firstNonEmpty([
    rowImageForSide(support,"Front"),
    rowImageForSide(row,"Front")
  ]);
}

function designCompositeHtml(d){
  var row=chooseFrontRow(d);
  var apparel=apparelImageFor(d,row);
  var artwork=frontArtworkUrl(d,row);
  var ap=resolveApparelPosition(d,row);
  var wp=resolveArtworkPosition(d,row);

  if(!apparel){
    var fallback=s(d&&(d.thumbnailUrl||d.previewUrl||d.frontArtworkUrl||d.sourceArtworkUrl));
    return fallback?'<img class="ua-pe-card__image" src="'+esc(fallback)+'" alt="'+esc(dtitle(d))+'" loading="lazy" decoding="async">':'';
  }

  var apparelStyle=[
    "position:absolute",
    hasPos(ap.leftPercent)?"left:"+Number(ap.leftPercent)+"%":"",
    hasPos(ap.topPercent)?"top:"+Number(ap.topPercent)+"%":"",
    hasPos(ap.widthPercent)?"width:"+(Number(ap.widthPercent)===175?200:Number(ap.widthPercent))+"%":"",
    hasPos(ap.heightPercent)?"height:"+Number(ap.heightPercent)+"%":"height:auto",
    "max-width:none","max-height:none",
    (hasPos(ap.translateXPercent)||hasPos(ap.translateYPercent))?
      "transform:translate("+Number(firstPos(ap.translateXPercent,0))+"%,"+Number(firstPos(ap.translateYPercent,0))+"%)"+(hasPos(ap.scale)?" scale("+Number(ap.scale)+")":"")+(Number(ap.rotationDeg||0)?" rotate("+Number(ap.rotationDeg)+"deg)":""):
      (hasPos(ap.scale)?"transform:scale("+Number(ap.scale)+")":"")
  ].filter(Boolean).join(";");

  var artworkStyle=[
    "position:absolute",
    hasPos(wp.leftPercent)?"left:"+Number(wp.leftPercent)+"%":"",
    hasPos(wp.topPercent)?"top:"+Number(wp.topPercent)+"%":"",
    hasPos(wp.artworkWidthPercent)?"width:"+Number(wp.artworkWidthPercent)+"%":"",
    "height:auto","max-width:none","max-height:none",
    "transform:translate("+Number(firstPos(wp.translateXPercent,-50))+"%,"+Number(firstPos(wp.translateYPercent,-50))+"%) rotate("+Number(wp.rotationDeg||0)+"deg)"
  ].filter(Boolean).join(";");

  var apparelKind=firstNonEmpty([
    row&&row.category,
    row&&row.type,
    row&&row.productType,
    row&&row.apparelType,
    row&&row.name,
    row&&row.productName
  ]);

  return '<div class="ua-pe-render" data-reference-stage="348x372" data-apparel-kind="'+esc(apparelKind)+'" data-matrix-applied="'+(matrixArtworkFor(d)?'yes':'no')+'" aria-label="'+esc(dtitle(d))+' rendered on apparel">'+
    '<div class="ua-pe-render__stage">'+
      '<img class="ua-pe-render__apparel" src="'+esc(apparel)+'" alt="" loading="lazy" decoding="async" style="'+apparelStyle+'">'+
      (artwork?'<img class="ua-pe-render__artwork" src="'+esc(artwork)+'" alt="" loading="lazy" decoding="async" style="'+artworkStyle+'">':'')+
    '</div>'+
  '</div>';
}
function designCard(d){
  var k=s(d&&(d.segment||d.collection||"PE Design"));
  return '<article class="ua-pe-card">'+
    '<button class="ua-pe-card__image-link ua-pe-card__image-link--rendered ua-pe-card__lightbox-trigger" type="button" data-pe-design-lightbox aria-label="View full image: '+esc(dtitle(d))+'">'+designCompositeHtml(d)+'</button>'+
    '<div class="ua-pe-card__body"><div class="ua-pe-card__kicker">'+esc(k||"PE Design")+'</div><h3 class="ua-pe-card__title">'+esc(dtitle(d))+'</h3>'+
    '<button class="ua-pe-card__action ua-pe-card__lightbox-trigger" type="button" data-pe-design-lightbox>View Full Image</button></div></article>';
}


function peArtworkSamples(rootEl){
  if(!rootEl)return [];
  if(rootEl.__uaPeArtworkSamples)return rootEl.__uaPeArtworkSamples;
  var node=rootEl.querySelector("[data-pe-artwork-samples]");
  var list=[];
  try{
    list=JSON.parse(node&&node.textContent||"[]");
  }catch(e){
    list=[];
  }
  list=(Array.isArray(list)?list:[]).filter(function(x){return x&&s(x.image)});
  rootEl.__uaPeArtworkSamples=list;
  return list;
}
function peArtworkAllowedFor(item,kind){
  var use=s(item&&item.use).toLowerCase()||"both";
  var family=kind==="short"?"bottom":kind;
  return use==="both"||use===family;
}
function peDefaultPlacement(item,kind){
  if(kind==="short")return "left-bottom-leg";
  if(kind==="bottom")return s(item&&item.default_bottom)||"top-left";
  return s(item&&item.default_top)||"full-front";
}
function peActualContainedImageBox(img,container){
  if(!img||!container)return null;
  var cr=container.getBoundingClientRect();
  var iw=Number(img.naturalWidth)||0,ih=Number(img.naturalHeight)||0;
  if(!iw||!ih||!cr.width||!cr.height)return null;

  var scale=Math.min(cr.width/iw,cr.height/ih);
  var rw=iw*scale,rh=ih*scale;
  return {
    left:(cr.width-rw)/2,
    top:(cr.height-rh)/2,
    width:rw,
    height:rh
  };
}
function peProductPlacementSpec(kind,key){
  /*
    Left/right follow the WEARER'S orientation.
    Coordinates are relative to the actual contained apparel image.
  */
  if(kind==="short"){
    return ({
      "left-bottom-leg":  {x:.64,y:.75,w:.16,rotate:0},
      "right-bottom-leg": {x:.36,y:.75,w:.16,rotate:0}
    })[key]||{x:.64,y:.69,w:.16,rotate:0};
  }
  if(kind==="bottom"){
    return ({
      "top-left":       {x:.64,y:.36,w:.15,rotate:0},
      "top-right":      {x:.36,y:.36,w:.15,rotate:0},
      "full-left-leg":  {x:.66,y:.59,w:.30,rotate:90},
      "full-right-leg": {x:.34,y:.59,w:.30,rotate:-90}
    })[key]||{x:.64,y:.36,w:.15,rotate:0};
  }
  return ({
    "full-front": {x:.50,y:.47,w:.33,rotate:0},
    "left-chest": {x:.575,y:.37,w:.13,rotate:0},
    "right-chest":{x:.425,y:.37,w:.13,rotate:0}
  })[key]||{x:.50,y:.47,w:.33,rotate:0};
}
function peSelectedArtwork(rootEl,card){
  var samples=peArtworkSamples(rootEl);
  var id=s(card&&card.dataset.peArtworkId);
  return samples.find(function(x){return s(x.id)===id})||null;
}
function peAvailableArtwork(rootEl,card){
  var kind=s(card&&card.dataset.peProductKind)||"top";
  var list=peArtworkSamples(rootEl).filter(function(x){return peArtworkAllowedFor(x,kind)});
  return list.length?[list[0]]:[];
}
function peRenderArtworkButtons(rootEl,card){
  var holder=card&&card.querySelector("[data-pe-preview-artworks]");
  if(!holder)return;
  var list=peAvailableArtwork(rootEl,card);
  var current=s(card.dataset.peArtworkId);

  holder.innerHTML=list.map(function(item){
    var active=s(item.id)===current;
    return '<button class="ua-pe-product-preview__artwork '+(active?"is-active":"")+'" type="button" data-pe-preview-artwork-id="'+esc(item.id)+'" aria-pressed="'+(active?"true":"false")+'" title="'+esc(item.title||"Artwork Sample")+'">'+
      '<span class="ua-pe-product-preview__artwork-frame"><img src="'+esc(item.image)+'" alt="'+esc(item.title||"Artwork Sample")+'" loading="lazy" decoding="async"></span>'+
      '<span class="ua-pe-product-preview__artwork-name">'+esc(item.title||"Artwork")+'</span>'+
    '</button>';
  }).join("");

  if(!list.length){
    holder.innerHTML='<div class="ua-pe-product-preview__empty">Add an Artwork Sample block in the Theme Editor.</div>';
  }
}
function peSyncPreviewControls(rootEl,card){
  var currentArt=s(card&&card.dataset.peArtworkId);
  var currentPlacement=s(card&&card.dataset.pePreviewPlacementCurrent);

  card.querySelectorAll("[data-pe-preview-artwork-id]").forEach(function(btn){
    var active=s(btn.getAttribute("data-pe-preview-artwork-id"))===currentArt;
    btn.classList.toggle("is-active",active);
    btn.setAttribute("aria-pressed",active?"true":"false");
  });
  card.querySelectorAll("[data-pe-preview-placement]").forEach(function(btn){
    var active=s(btn.getAttribute("data-pe-preview-placement"))===currentPlacement;
    btn.classList.toggle("is-active",active);
    btn.setAttribute("aria-pressed",active?"true":"false");
  });
}
function pePositionProductArtwork(rootEl,card){
  if(!card||!card.classList.contains("is-pe-previewing"))return;
  var apparel=card.querySelector(".ua-pe-card__image");
  var container=card.querySelector(".ua-pe-card__image-link--previewable");
  var art=card.querySelector("[data-pe-product-artwork]");
  var item=peSelectedArtwork(rootEl,card);
  if(!apparel||!container||!art||!item)return;

  var box=peActualContainedImageBox(apparel,container);
  if(!box)return;

  var kind=s(card.dataset.peProductKind)||"top";
  var key=s(card.dataset.pePreviewPlacementCurrent)||peDefaultPlacement(item,kind);
  var spec=peProductPlacementSpec(kind,key);

  var artworkScale=Math.max(.5,Math.min(1.5,(Number(item.scale)||100)/100));
  var renderedWidth=Math.max(18,box.width*spec.w*artworkScale);
  var renderedLeft=box.left+box.width*spec.x;
  var renderedTop=box.top+box.height*spec.y;

  /* V57: calibrated chest placement.
     Left Chest remains calibrated at left 190px / top 128px; V60 locks chest artwork width to an actual 25px, independent of the artwork-size slider.
     Right Chest is mirrored from that approved Left Chest position so both
     chest placements stay equally inset from the garment preview center. */
  if(kind==="top"&&(key==="left-chest"||key==="right-chest")&&container.clientWidth>=260){
    var approvedLeftChestX=190;
    renderedWidth=25;
    renderedTop=128;
    renderedLeft=(key==="left-chest")
      ? approvedLeftChestX
      : (container.clientWidth-approvedLeftChestX);
  }

  /* V63: lock shorts artwork lower in the product-card preview.
     Applies only to the two shorts placements; pants/joggers are unchanged. */
  if(kind==="short"&&(key==="left-bottom-leg"||key==="right-bottom-leg")&&container.clientWidth>=260){
    renderedTop=260;
  }

  art.style.setProperty("width",renderedWidth+"px","important");
  art.style.setProperty("height","auto","important");
  art.style.setProperty("left",renderedLeft+"px","important");
  art.style.setProperty("top",renderedTop+"px","important");
  art.style.setProperty("transform","translate(-50%,-50%) rotate("+Number(spec.rotate||0)+"deg)","important");
}
function peSetArtwork(rootEl,card,item,useDefaultPlacement){
  if(!rootEl||!card||!item)return;
  var kind=s(card.dataset.peProductKind)||"top";
  var art=card.querySelector("[data-pe-product-artwork]");

  card.dataset.peArtworkId=s(item.id);
  if(useDefaultPlacement||!s(card.dataset.pePreviewPlacementCurrent)){
    card.dataset.pePreviewPlacementCurrent=peDefaultPlacement(item,kind);
  }

  if(art){
    art.src=s(item.image);
    art.alt=s(item.title||"Artwork Sample");
    art.setAttribute("aria-hidden","true");
  }

  card.classList.add("is-pe-previewing");
  peRenderArtworkButtons(rootEl,card);
  peSyncPreviewControls(rootEl,card);

  if(art&&!art.complete){
    art.addEventListener("load",function(){pePositionProductArtwork(rootEl,card)},{once:true});
  }
  var apparel=card.querySelector(".ua-pe-card__image");
  if(apparel&&!apparel.complete){
    apparel.addEventListener("load",function(){pePositionProductArtwork(rootEl,card)},{once:true});
  }

  window.requestAnimationFrame(function(){pePositionProductArtwork(rootEl,card)});
}
function peEnableProductPreview(rootEl,card){
  var list=peAvailableArtwork(rootEl,card);
  var toggle=card.querySelector("[data-pe-preview-toggle]");
  var panel=card.querySelector("[data-pe-preview-panel]");
  if(toggle){
    toggle.textContent="Artwork Preview On";
    toggle.setAttribute("aria-expanded","true");
  }
  if(panel)panel.hidden=false;

  peRenderArtworkButtons(rootEl,card);

  if(!list.length)return;
  var current=peSelectedArtwork(rootEl,card);
  if(!current||!peArtworkAllowedFor(current,s(card.dataset.peProductKind)||"top")){
    current=list[0];
  }
  peSetArtwork(rootEl,card,current,!s(card.dataset.pePreviewPlacementCurrent));
}
function peDisableProductPreview(card){
  if(!card)return;
  card.classList.remove("is-pe-previewing");
  var toggle=card.querySelector("[data-pe-preview-toggle]");
  var panel=card.querySelector("[data-pe-preview-panel]");
  var art=card.querySelector("[data-pe-product-artwork]");

  if(toggle){
    toggle.textContent="Preview Design on Apparel";
    toggle.setAttribute("aria-expanded","false");
  }
  if(panel)panel.hidden=true;
  if(art){
    art.removeAttribute("src");
    art.removeAttribute("style");
  }
}

function peEnsureProductPreviewLightbox(){
  var modal=document.getElementById("uaPeProductPreviewLightbox");
  if(modal)return modal;

  modal=document.createElement("div");
  modal.id="uaPeProductPreviewLightbox";
  modal.className="ua-pe-product-lightbox";
  modal.setAttribute("aria-hidden","true");
  modal.innerHTML=
    '<div class="ua-pe-product-lightbox__backdrop" data-pe-product-lightbox-close></div>'+
    '<div class="ua-pe-product-lightbox__dialog" role="dialog" aria-modal="true" aria-labelledby="uaPeProductLightboxTitle">'+
      '<button class="ua-pe-product-lightbox__close" type="button" data-pe-product-lightbox-close aria-label="Close preview">×</button>'+
      '<div class="ua-pe-product-lightbox__layout">'+
        '<div class="ua-pe-product-lightbox__main">'+
          '<div class="ua-pe-product-lightbox__stage" data-pe-product-lightbox-stage>'+
            '<img class="ua-pe-product-lightbox__apparel" data-pe-product-lightbox-apparel alt="">'+
            '<img class="ua-pe-product-lightbox__artwork" data-pe-product-lightbox-artwork alt="" aria-hidden="true">'+
          '</div>'+
          '<div class="ua-pe-product-lightbox__meta">'+
        '<h3 class="ua-pe-product-lightbox__title" id="uaPeProductLightboxTitle" data-pe-product-lightbox-title>Preview</h3>'+
        '<div class="ua-pe-product-lightbox__section">'+
          '<div class="ua-pe-product-lightbox__label">Artwork</div>'+
          '<div class="ua-pe-product-lightbox__artworks" data-pe-product-lightbox-artworks></div>'+
        '</div>'+
        '<div class="ua-pe-product-lightbox__section ua-pe-product-lightbox__upload">'+
          '<div class="ua-pe-product-lightbox__label">Try your artwork</div>'+
          '<div class="ua-pe-product-lightbox__upload-row">'+
            '<label class="ua-pe-product-lightbox__upload-button">Upload PNG / JPG / WebP<input type="file" accept="image/png,image/jpeg,image/webp" data-pe-product-lightbox-upload></label>'+
            '<label class="ua-pe-product-lightbox__remove-bg"><input type="checkbox" data-pe-product-lightbox-remove-white> Remove white background</label>'+
            '<button class="ua-pe-product-lightbox__remove-upload" type="button" data-pe-product-lightbox-remove-upload hidden>Remove uploaded artwork</button>'+
          '</div>'+
          '<div class="ua-pe-product-lightbox__upload-note" data-pe-product-lightbox-upload-note>For best results, use a transparent PNG. Your image is processed only in this browser preview and is not saved.</div>'+
        '</div>'+
        '<div class="ua-pe-product-lightbox__section">'+
          '<div class="ua-pe-product-lightbox__label">Placement</div>'+
          '<div class="ua-pe-product-lightbox__placements" data-pe-product-lightbox-placements></div>'+
        '</div>'+
        '<div class="ua-pe-product-lightbox__section">'+
          '<div class="ua-pe-product-lightbox__label">Adjust Artwork</div>'+
          '<div class="ua-pe-product-lightbox__adjustments">'+
            '<div class="ua-pe-product-lightbox__adjustment">'+
              '<label class="ua-pe-product-lightbox__adjustment-label" for="uaPeAdjustSize">Size %</label>'+
              '<div class="ua-pe-product-lightbox__adjustment-controls">'+
                '<input class="ua-pe-product-lightbox__range" id="uaPeAdjustSize" type="range" min="40" max="200" step="1" value="100" data-pe-product-lightbox-adjust="sizePct">'+
                '<input class="ua-pe-product-lightbox__number" type="number" min="40" max="200" step="1" value="100" data-pe-product-lightbox-adjust-number="sizePct">'+
              '</div>'+
            '</div>'+
            '<div class="ua-pe-product-lightbox__adjustment">'+
              '<label class="ua-pe-product-lightbox__adjustment-label" for="uaPeAdjustX">X</label>'+
              '<div class="ua-pe-product-lightbox__adjustment-controls">'+
                '<input class="ua-pe-product-lightbox__range" id="uaPeAdjustX" type="range" min="-160" max="160" step="1" value="0" data-pe-product-lightbox-adjust="x">'+
                '<input class="ua-pe-product-lightbox__number" type="number" min="-160" max="160" step="1" value="0" data-pe-product-lightbox-adjust-number="x">'+
              '</div>'+
            '</div>'+
            '<div class="ua-pe-product-lightbox__adjustment">'+
              '<label class="ua-pe-product-lightbox__adjustment-label" for="uaPeAdjustY">Y</label>'+
              '<div class="ua-pe-product-lightbox__adjustment-controls">'+
                '<input class="ua-pe-product-lightbox__range" id="uaPeAdjustY" type="range" min="-160" max="160" step="1" value="0" data-pe-product-lightbox-adjust="y">'+
                '<input class="ua-pe-product-lightbox__number" type="number" min="-160" max="160" step="1" value="0" data-pe-product-lightbox-adjust-number="y">'+
              '</div>'+
            '</div>'+
            '<button class="ua-pe-product-lightbox__adjustment-reset" type="button" data-pe-product-lightbox-adjust-reset>Reset adjustments</button>'+
          '</div>'+
        '</div>'+
          '</div>'+
        '</div>'+
        '<aside class="ua-pe-product-lightbox__commerce" aria-label="Continue to Design Studio">'+
          '<div class="ua-pe-product-lightbox__commerce-head">'+
            '<div class="ua-pe-product-lightbox__label">Continue to Design Studio</div>'+
            '<div class="ua-pe-product-lightbox__commerce-subtitle">Your selected apparel, artwork, placement, and preview adjustments will be sent to InkSoft. Choose quantities and review pricing inside Design Studio.</div>'+
          '</div>'+
          '<div class="ua-pe-product-lightbox__calc">'+
            '<button class="ua-pe-product-lightbox__action ua-pe-product-lightbox__action--cart" type="button" data-pe-product-lightbox-add-cart>Continue to Design Studio</button>'+
            '<div class="ua-pe-product-lightbox__cart-note" data-pe-product-lightbox-cart-note>Quantity and pricing will be completed in InkSoft Design Studio.</div>'+
          '</div>'+
          '<div class="ua-pe-product-lightbox__actions">'+
            '<a class="ua-pe-product-lightbox__action ua-pe-product-lightbox__action--secondary" href="#" data-pe-product-lightbox-open-product>Open Product Detail</a>'+
          '</div>'+
        '</aside>'+
      '</div>'+
    '</div>';

  document.body.appendChild(modal);

  modal.addEventListener("change",function(ev){
    var upload=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-product-lightbox-upload]");
    var remove=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-product-lightbox-remove-white]");
    var adjustNumber=ev.target&&ev.target.matches&&ev.target.matches("[data-pe-product-lightbox-adjust-number]")?ev.target:null;
    if(adjustNumber){
      peUpdateLightboxAdjustment(modal,s(adjustNumber.getAttribute("data-pe-product-lightbox-adjust-number")),adjustNumber.value);
      return;
    }

    if(upload){
      var file=upload.files&&upload.files[0];
      if(!file)return;
      if(!/^image\/(png|jpeg|webp)$/i.test(file.type||"")){
        peProductUploadNote(modal,"Please choose a PNG, JPG, or WebP image.",true);
        upload.value="";
        return;
      }
      if(file.size>8*1024*1024){
        peProductUploadNote(modal,"Please use an image smaller than 8 MB.",true);
        upload.value="";
        return;
      }
      modal._peCustomerArtworkFile=file;
      peLoadCustomerArtwork(modal,file,!!(modal.querySelector("[data-pe-product-lightbox-remove-white]")||{}).checked);
      return;
    }

    if(remove&&modal._peCustomerArtworkFile){
      peLoadCustomerArtwork(modal,modal._peCustomerArtworkFile,!!remove.checked);
    }
  });

  modal.addEventListener("click",function(ev){
    if(ev.target&&ev.target.closest("[data-pe-product-lightbox-close]")){
      peCloseProductPreviewLightbox();
      return;
    }

    var artBtn=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-product-lightbox-artwork-id]");
    if(artBtn){
      var id=s(artBtn.getAttribute("data-pe-product-lightbox-artwork-id"));
      var data=modal._pePreviewData||{};
      var item=(data.artworks||[]).find(function(a){return s(a.id)===id});
      if(item){
        data.artwork=item;
        data.placement=peDefaultPlacement(item,data.kind||"top");
        modal._pePreviewData=data;
        peRenderProductPreviewLightbox(modal);
      }
      return;
    }

    var posBtn=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-product-lightbox-placement]");
    if(posBtn){
      var data2=modal._pePreviewData||{};
      data2.placement=s(posBtn.getAttribute("data-pe-product-lightbox-placement"));
      modal._pePreviewData=data2;
      peRenderProductPreviewLightbox(modal);
      return;
    }

    var resetBtn=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-product-lightbox-adjust-reset]");
    if(resetBtn){
      peResetLightboxAdjustments(modal);
      return;
    }

    var removeUploadBtn=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-product-lightbox-remove-upload]");
    if(removeUploadBtn){
      peRemoveCustomerArtwork(modal);
      return;
    }


    var addCartBtn=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-product-lightbox-add-cart]");
    if(addCartBtn){
      peAddProductPreviewToCart(modal);
      return;
    }
  });

  modal.addEventListener("input",function(ev){
    var adjust=ev.target&&ev.target.matches&&ev.target.matches("[data-pe-product-lightbox-adjust]")?ev.target:null;
    if(adjust){
      peUpdateLightboxAdjustment(modal,s(adjust.getAttribute("data-pe-product-lightbox-adjust")),adjust.value);
      return;
    }
    var adjustNumber=ev.target&&ev.target.matches&&ev.target.matches("[data-pe-product-lightbox-adjust-number]")?ev.target:null;
    if(adjustNumber){
      peUpdateLightboxAdjustment(modal,s(adjustNumber.getAttribute("data-pe-product-lightbox-adjust-number")),adjustNumber.value);
      return;
    }
  });

  document.addEventListener("keydown",function(ev){
    if(ev.key==="Escape"&&modal.classList.contains("is-open"))peCloseProductPreviewLightbox();
  });

  window.addEventListener("resize",function(){
    if(modal.classList.contains("is-open"))window.requestAnimationFrame(function(){pePositionProductLightboxArtwork(modal)});
  });

  return modal;
}


function peProductUploadNote(modal,msg,isError){
  var el=modal&&modal.querySelector("[data-pe-product-lightbox-upload-note]");
  if(!el)return;
  el.textContent=msg||"";
  el.classList.toggle("is-error",!!isError);
}
function peProductCartNote(modal,msg,isError){
  var el=modal&&modal.querySelector("[data-pe-product-lightbox-cart-note]");
  if(!el)return;
  el.textContent=msg||"";
  el.classList.toggle("is-error",!!isError);
}
function peFormatMoney(value){
  var n=Number(value);
  if(!Number.isFinite(n))n=0;
  return '$'+n.toFixed(2);
}
function peQuickPriceError(modal,msg){
  var el=modal&&modal.querySelector("[data-pe-product-lightbox-qp-error]");
  if(!el)return;
  el.hidden=!msg;
  el.textContent=msg||"";
}
function peInvalidateQuickPriceQuote(modal,msg){
  if(!modal)return;
  var data=modal._pePreviewData||{};
  data.quickPriceQuote=null;
  data.quickPricePayload=null;
  data.qty=0;
  data.unitPrice=0;
  data.total=0;
  modal._pePreviewData=data;
  var result=modal.querySelector("[data-pe-product-lightbox-qp-result]");
  if(result)result.hidden=true;
  var add=modal.querySelector("[data-pe-product-lightbox-add-cart]");
  if(add)add.disabled=true;
  peProductCartNote(modal,msg||"Calculate a Quick Price first, then add this configured preview to cart.",false);
}
function peRenderQuickPriceSizes(modal){
  if(!modal)return;
  var data=modal._pePreviewData||{};
  var box=modal.querySelector("[data-pe-product-lightbox-qp-sizes]");
  if(!box)return;
  var rows=arr(data.sizeRows);
  if(!rows.length){box.innerHTML='<div class="ua-pe-product-lightbox__calc-help">Size quantities are unavailable for this style. Open Product Detail for the full calculator.</div>';return;}
  var minQty=Math.max(1,Math.round(numVal(data.productMinimumQuantity)||1));
  box.innerHTML='<div class="ua-pe-product-lightbox__label ua-pe-product-lightbox__qp-heading"><span>Quantities by size</span><span class="ua-pe-product-lightbox__qp-minimum">Minimum: '+esc(minQty)+' pcs</span></div>'+rows.map(function(row){return '<label class="ua-pe-product-lightbox__qp-size"><span>'+esc(row.label)+'</span><input class="ua-pe-product-lightbox__number" type="number" min="0" step="1" value="0" data-pe-product-lightbox-size-id="'+esc(row.id)+'" data-pe-product-lightbox-size-label="'+esc(row.label)+'"></label>'}).join('')+'<div class="ua-pe-product-lightbox__calc-help">Total quantity across all sizes must meet the InkSoft minimum of '+esc(minQty)+' pieces.</div>';
}
function peQuickPricePayload(modal){
  var data=modal._pePreviewData||{};
  var colorInput=modal.querySelector("[data-pe-product-lightbox-artwork-colors]");
  var colors=Math.round(peClampNumber(colorInput&&colorInput.value,1,6,Number(data.artworkColorCount)||1));
  data.artworkColorCount=colors;
  modal._pePreviewData=data;
  var sizes=Array.from(modal.querySelectorAll("[data-pe-product-lightbox-size-id]")).map(function(input){return {productStyleSizeId:numVal(input.getAttribute("data-pe-product-lightbox-size-id")),sizeLabel:s(input.getAttribute("data-pe-product-lightbox-size-label")),quantity:Math.max(0,Math.floor(numVal(input.value)))};}).filter(function(row){return row.quantity>0});
  var sideLabel=pePlacementLabel(data.placement||"full-front");
  return {
    productId:numVal(data.productId),
    productStyleId:numVal(data.styleId),
    storeId:numVal(data.quickPriceStoreId)||13457,
    selectedColor:s(data.selectedColor),
    productTags:arr(data.productTags),
    productMinimumQuantity:Math.max(1,Math.round(numVal(data.productMinimumQuantity)||1)),
    sizes:sizes,
    sides:[{sideId:"Front",sideLabel:sideLabel||"Front",colorMode:"spot-colors",colorLabel:colors+" Color"+(colors===1?"":"s"),numColors:colors,isFullColor:false}]
  };
}
async function peCalculateLiveQuickPrice(modal){
  var data=modal._pePreviewData||{};
  var btn=modal.querySelector("[data-pe-product-lightbox-calculate]");
  var result=modal.querySelector("[data-pe-product-lightbox-qp-result]");
  var payload=peQuickPricePayload(modal);
  var totalQty=payload.sizes.reduce(function(n,row){return n+row.quantity},0);
  peQuickPriceError(modal,"");
  if(!payload.productId||!payload.productStyleId){peQuickPriceError(modal,"This PE product is missing the product/style ID needed for Quick Price.");return;}
  if(!payload.sizes.length){peQuickPriceError(modal,"Enter a quantity for at least one size.");return;}
  var missingSizeIds=payload.sizes.filter(function(row){return !(Number(row.productStyleSizeId)>0);});
  if(missingSizeIds.length){
    peQuickPriceError(modal,"The InkSoft size IDs are still loading or unavailable for: "+missingSizeIds.map(function(row){return row.sizeLabel}).join(", ")+". Close and reopen Preview if needed.");
    return;
  }
  if(totalQty<payload.productMinimumQuantity){peQuickPriceError(modal,"InkSoft minimum quantity for this apparel is "+payload.productMinimumQuantity+" pieces. Current total: "+totalQty+".");return;}
  if(!data.quickPriceEndpoint){peQuickPriceError(modal,"Quick Price endpoint is not configured.");return;}
  if(btn){btn.disabled=true;btn.textContent="Calculating…";}
  try{
    var response=await fetch(data.quickPriceEndpoint,{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:JSON.stringify(payload)});
    var body=await response.json();
    if(!response.ok||!body.success)throw new Error((body&&body.error&&body.error.message)||body.error||"Quick Price request failed.");
    var q=body.data||{};
    var summary=q.summary||{};
    var subtotal=Number.isFinite(Number(summary.estimatedSubtotal))?Number(summary.estimatedSubtotal):Number(summary.total||0);
    var each=Number.isFinite(Number(summary.estimatedUnitPrice))?Number(summary.estimatedUnitPrice):Number(summary.each||0);
    data.quickPriceQuote=q;data.quickPricePayload=payload;data.qty=totalQty;data.unitPrice=each;data.total=subtotal;modal._pePreviewData=data;
    if(result){result.hidden=false;result.innerHTML='<div class="ua-pe-product-lightbox__qp-summary"><div><span>Total quantity</span><strong>'+esc(totalQty)+'</strong></div><div><span>Estimated price / piece</span><strong>'+esc(peFormatMoney(each))+'</strong></div><div class="is-total"><span>Estimated item subtotal</span><strong>'+esc(peFormatMoney(subtotal))+'</strong></div><small>Uses the PE apparel price and Quick Price/PE pricing matrix. Tax and shipping are not included.</small></div>'; }
    var addCart=modal.querySelector("[data-pe-product-lightbox-add-cart]");
    if(addCart)addCart.disabled=false;
    peProductCartNote(modal,"Quick Price ready. Add this configured apparel and artwork preview to cart.",false);
  }catch(err){
    peQuickPriceError(modal,s(err&&err.message)||"Unable to calculate Quick Price.");
    if(result)result.hidden=true;
  }finally{if(btn){btn.disabled=false;btn.textContent="Get Quick Price";}}
}
function peRemoveCustomerArtwork(modal){
  if(!modal)return;
  var data=modal._pePreviewData||{};
  var artworks=(data.artworks||[]).filter(function(a){return !a.customer;});
  data.artworks=artworks;
  data.artwork=artworks[0]||null;
  data.placement=data.artwork?peDefaultPlacement(data.artwork,data.kind||"top"):"";
  data.adjustments=peDefaultLightboxAdjustments();
  modal._pePreviewData=data;
  var uploadInput=modal.querySelector("[data-pe-product-lightbox-upload]");
  if(uploadInput)uploadInput.value="";
  peRenderProductPreviewLightbox(modal);
  peProductUploadNote(modal,"Uploaded artwork removed.",false);
}
function peAbsoluteImageUrl(value){
  var raw=s(value);
  if(!raw)return "";
  if(/^data:image\//i.test(raw))return raw;
  if(/^blob:/i.test(raw))return raw;
  try{
    if(raw.indexOf("//")===0)return window.location.protocol+raw;
    return new URL(raw,window.location.origin).href;
  }catch(e){
    return raw;
  }
}
function peServerRenderSpec(modal){
  var data=modal&&modal._pePreviewData||{};
  var apparel=modal&&modal.querySelector("[data-pe-product-lightbox-apparel]");
  var artwork=modal&&modal.querySelector("[data-pe-product-lightbox-artwork]");
  var stage=modal&&modal.querySelector("[data-pe-product-lightbox-stage]");
  if(!apparel||!stage)return null;
  var spec=peProductPlacementSpec(data.kind||"top",data.placement||peDefaultPlacement(data.artwork,data.kind||"top"));
  var box=peActualContainedImageBox(apparel,stage)||{width:apparel.clientWidth||1,height:apparel.clientHeight||1};
  var itemScale=Math.max(.5,Math.min(2,(Number(data.artwork&&data.artwork.scale)||100)/100));
  var adj=peEnsureLightboxAdjustments(modal);
  var manualScale=Math.max(.4,Math.min(2,Number(adj.sizePct||100)/100));
  var widthRatio=Number(spec.w||.2)*itemScale*manualScale;
  var productAspect=(apparel.naturalWidth&&apparel.naturalHeight)
    ? (apparel.naturalHeight/apparel.naturalWidth)
    : ((box.width&&box.height)?(box.height/box.width):1);
  var artworkAspect=(artwork&&artwork.naturalWidth&&artwork.naturalHeight)
    ? (artwork.naturalHeight/artwork.naturalWidth)
    : 1;
  var heightRatio=widthRatio*(1/Math.max(.01,productAspect))*artworkAspect;
  return {
    xRatio:Number(spec.x||.5)+(Number(adj.x||0)/Math.max(1,Number(box.width)||1)),
    yRatio:Number(spec.y||.5)+(Number(adj.y||0)/Math.max(1,Number(box.height)||1)),
    widthRatio:widthRatio,
    heightRatio:heightRatio,
    productAspect:productAspect,
    rotationDeg:Number(spec.rotate||0),
    placement:s(data.placement||""),
    kind:s(data.kind||"top")
  };
}
function peBuildProductPreviewSnapshot(modal){
  return new Promise(function(resolve){
    try{
      var data=modal._pePreviewData||{};
      var apparel=modal.querySelector("[data-pe-product-lightbox-apparel]");
      var artwork=modal.querySelector("[data-pe-product-lightbox-artwork]");
      var stage=modal.querySelector("[data-pe-product-lightbox-stage]");
      if(!apparel||!artwork||!data.artwork||!apparel.naturalWidth||!apparel.naturalHeight){resolve("");return;}
      var cw=apparel.naturalWidth,ch=apparel.naturalHeight;
      var canvas=document.createElement('canvas');
      canvas.width=cw; canvas.height=ch;
      var ctx=canvas.getContext('2d');
      ctx.drawImage(apparel,0,0,cw,ch);
      if(artwork.naturalWidth&&artwork.naturalHeight){
        var spec=peProductPlacementSpec(data.kind||"top",data.placement||peDefaultPlacement(data.artwork,data.kind||"top"));
        var box=peActualContainedImageBox(apparel,stage)||{left:0,top:0,width:apparel.clientWidth||1,height:apparel.clientHeight||1};
        var itemScale=Math.max(.5,Math.min(2,(Number(data.artwork.scale)||100)/100));
        var adj=peEnsureLightboxAdjustments(modal);
        var manualScale=Math.max(.4,Math.min(2,Number(adj.sizePct||100)/100));
        var w=cw*spec.w*itemScale*manualScale;
        var h=(artwork.naturalHeight/artwork.naturalWidth)*w;
        var left=(cw*spec.x)+(Number(adj.x||0)*(cw/Math.max(1,box.width)));
        var top=(ch*spec.y)+(Number(adj.y||0)*(ch/Math.max(1,box.height)));
        ctx.save();
        ctx.translate(left,top);
        ctx.rotate((Number(spec.rotate||0)*Math.PI)/180);
        ctx.drawImage(artwork,-w/2,-h/2,w,h);
        ctx.restore();
      }
      resolve(canvas.toDataURL('image/png'));
    }catch(err){
      resolve("");
    }
  });
}
async function peAddProductPreviewToCart(modal){
  if(!modal)return;

  var btn=modal.querySelector("[data-pe-product-lightbox-add-cart]");
  if(btn){btn.disabled=true;btn.textContent="Opening Design Studio…";}
  peProductCartNote(modal,"Saving artwork and opening InkSoft Design Studio…",false);

  try{
    var current=modal._pePreviewData||{};
    var endpoint=s(current.cartEndpoint);
    if(!endpoint)throw new Error("InkSoft Design Studio endpoint is not configured.");

    var placementLabel=pePlacementLabel(current.placement||"")||"Front";
    var storedSession="";
    try{storedSession=localStorage.getItem("uaPeInksoftSessionToken")||"";}catch(e){}

    var artwork=null;
    if(current.artwork){
      var aid=numVal(current.artwork.artId||current.artwork.ArtId);
      var auid=s(current.artwork.artUniqueId||current.artwork.ArtUniqueId||current.artwork.uniqueId);
      if(aid>0||auid){
        artwork={
          artId:aid>0?aid:null,
          artUniqueId:auid,
          fileName:s(current.artwork.fileName||current.artwork.title||"PE artwork"),
          designName:(current.title||"PE Uniform")+" - "+placementLabel
        };
      }
    }

    var renderedPreviewDataUrl=await peBuildProductPreviewSnapshot(modal);
    var artworkImageUrl=peAbsoluteImageUrl(current.artwork&&current.artwork.image);
    var productImageUrl=peAbsoluteImageUrl(current.apparelImage);
    var serverRender=peServerRenderSpec(modal);

    var cartPayload={
      mode:"design-studio",
      productId:numVal(current.productId),
      productStyleId:numVal(current.styleId),
      storeId:13457,
      selectedColor:s(current.selectedColor),

      /*
       * V92 SIMPLE DESIGN-STUDIO HANDOFF:
       * Quick Price and quantity handoff are intentionally removed.
       * InkSoft Design Studio owns quantity entry and pricing from this point.
       */
      sizes:[],

      sides:[{
        sideId:"Front",
        sideLabel:placementLabel,
        decorationMethod:"ScreenPrint",
        regionName:"Full"
      }],

      designName:(current.title||"PE Uniform")+" - "+placementLabel,
      notes:"PE Design Studio handoff | Preview placement: "+placementLabel+
        " | Preview adjustments: size "+Math.round(Number((current.adjustments||{}).sizePct)||100)+
        "%, X "+Math.round(Number((current.adjustments||{}).x)||0)+
        ", Y "+Math.round(Number((current.adjustments||{}).y)||0),

      sessionToken:storedSession||undefined,
      previousSessionToken:storedSession||undefined,
      createNewCart:storedSession?false:true,
      artwork:artwork||undefined,

      preview:{
        sideName:"Front",
        productOnlyUrl:productImageUrl||undefined,
        designOnlyUrl:artworkImageUrl||undefined,
        designOnProductUrl:renderedPreviewDataUrl||undefined,
        sideArtId:artwork&&artwork.artId?artwork.artId:null,
        render:serverRender||undefined
      }
    };

    if(!cartPayload.productId||!cartPayload.productStyleId){
      throw new Error("Missing InkSoft product/style ID.");
    }
    if(!cartPayload.preview.designOnlyUrl){
      throw new Error("Artwork image is unavailable for Design Studio.");
    }

    var response=await fetch(endpoint,{
      method:"POST",
      headers:{Accept:"application/json","Content-Type":"application/json"},
      body:JSON.stringify(cartPayload)
    });

    var body=await response.json().catch(function(){return {};});
    if(!response.ok||!body.success){
      throw new Error(s(body&&body.error)||"InkSoft Design Studio request failed.");
    }

    if(body.sessionToken){
      try{localStorage.setItem("uaPeInksoftSessionToken",body.sessionToken);}catch(e){}
    }

    peProductCartNote(modal,"Design saved. Opening InkSoft Design Studio…",false);
    if(btn)btn.textContent="Opening…";

    var destination=s(body.studioUrl);
    if(destination){
      window.location.assign(destination);
      return;
    }

    throw new Error("InkSoft saved the design but did not return a Design Studio URL.");
  }catch(err){
    peProductCartNote(modal,s(err&&err.message)||"Unable to open this PE design in InkSoft Design Studio.",true);
    if(btn){btn.disabled=false;btn.textContent="Continue to Design Studio";}
  }
}

function peDefaultLightboxAdjustments(){
  return {sizePct:100,x:0,y:0};
}
function peClampNumber(value,min,max,fallback){
  var n=Number(value);
  if(!Number.isFinite(n))n=fallback;
  if(Number.isFinite(min))n=Math.max(min,n);
  if(Number.isFinite(max))n=Math.min(max,n);
  return n;
}
function peEnsureLightboxAdjustments(modal){
  var data=modal._pePreviewData||{};
  var current=data.adjustments||{};
  data.adjustments={
    sizePct:peClampNumber(current.sizePct,40,200,100),
    x:peClampNumber(current.x,-160,160,0),
    y:peClampNumber(current.y,-160,160,0)
  };
  modal._pePreviewData=data;
  return data.adjustments;
}
function peSyncLightboxAdjustmentInputs(modal){
  var adj=peEnsureLightboxAdjustments(modal);
  ["sizePct","x","y"].forEach(function(key){
    modal.querySelectorAll('[data-pe-product-lightbox-adjust="'+key+'"],[data-pe-product-lightbox-adjust-number="'+key+'"]').forEach(function(el){
      el.value=String(adj[key]);
    });
  });
}
function peUpdateLightboxAdjustment(modal,key,value){
  if(!modal)return;
  var data=modal._pePreviewData||{};
  var adj=peEnsureLightboxAdjustments(modal);
  if(key==="sizePct")adj.sizePct=peClampNumber(value,40,200,100);
  if(key==="x")adj.x=peClampNumber(value,-160,160,0);
  if(key==="y")adj.y=peClampNumber(value,-160,160,0);
  data.adjustments=adj;
  modal._pePreviewData=data;
  peSyncLightboxAdjustmentInputs(modal);
  window.requestAnimationFrame(function(){pePositionProductLightboxArtwork(modal)});
}
function peResetLightboxAdjustments(modal){
  if(!modal)return;
  var data=modal._pePreviewData||{};
  data.adjustments=peDefaultLightboxAdjustments();
  modal._pePreviewData=data;
  peSyncLightboxAdjustmentInputs(modal);
  window.requestAnimationFrame(function(){pePositionProductLightboxArtwork(modal)});
}

function peLoadCustomerArtwork(modal,file,removeWhite){
  if(!modal||!file)return;
  peProductUploadNote(modal,"Preparing your artwork…",false);
  var reader=new FileReader();
  reader.onload=function(){
    var img=new Image();
    img.onload=function(){
      try{
        var source=pePrepareCustomerArtworkCanvas(img,removeWhite);
        var dataUrl=source.toDataURL("image/png");
        var data=modal._pePreviewData||{};
        var item={
          id:"customer-upload",
          title:"Your Artwork",
          image:dataUrl,
          scale:100,
          availability:"both",
          default_top:"full-front",
          default_short:"right-bottom-leg",
          default_bottom:"top-left",
          customer:true
        };
        var arts=(data.artworks||[]).filter(function(a){return !a.customer&&s(a.id)!=="customer-upload"});
        arts.push(item);
        data.artworks=arts;
        data.artwork=item;
        data.placement=peDefaultPlacement(item,data.kind||"top");
        modal._pePreviewData=data;
        peRenderProductPreviewLightbox(modal);
        peProductUploadNote(modal,removeWhite?"White background removed for this preview. Your file is not saved.":"Your artwork is ready. Your file is not saved.",false);
      }catch(err){
        peProductUploadNote(modal,"This image could not be prepared. Try a transparent PNG.",true);
      }
    };
    img.onerror=function(){peProductUploadNote(modal,"This image could not be read.",true);};
    img.src=reader.result;
  };
  reader.onerror=function(){peProductUploadNote(modal,"This image could not be read.",true);};
  reader.readAsDataURL(file);
}

function pePrepareCustomerArtworkCanvas(img,removeWhite){
  var maxSide=1600;
  var iw=Math.max(1,img.naturalWidth||img.width||1);
  var ih=Math.max(1,img.naturalHeight||img.height||1);
  var ratio=Math.min(1,maxSide/Math.max(iw,ih));
  var w=Math.max(1,Math.round(iw*ratio));
  var h=Math.max(1,Math.round(ih*ratio));
  var c=document.createElement("canvas");
  c.width=w;c.height=h;
  var ctx=c.getContext("2d",{willReadFrequently:!!removeWhite});
  ctx.clearRect(0,0,w,h);
  ctx.drawImage(img,0,0,w,h);
  if(removeWhite)peRemoveEdgeConnectedWhite(ctx,w,h);
  return c;
}

/* Removes only near-white pixels connected to the image edges.
   This is safer than deleting every white pixel because internal white
   portions of a logo are preserved when they are enclosed by colored art. */
function peRemoveEdgeConnectedWhite(ctx,w,h){
  var image=ctx.getImageData(0,0,w,h);
  var d=image.data;
  var count=w*h;
  var seen=new Uint8Array(count);
  var q=new Int32Array(count);
  var head=0,tail=0;

  function eligible(i){
    var p=i*4;
    var a=d[p+3];
    if(a<10)return true;
    var r=d[p],g=d[p+1],b=d[p+2];
    var max=Math.max(r,g,b),min=Math.min(r,g,b);
    return r>=238&&g>=238&&b>=238&&(max-min)<=18;
  }
  function push(i){
    if(i<0||i>=count||seen[i]||!eligible(i))return;
    seen[i]=1;q[tail++]=i;
  }
  for(var x=0;x<w;x++){push(x);push((h-1)*w+x);}
  for(var y=0;y<h;y++){push(y*w);push(y*w+w-1);}
  while(head<tail){
    var i=q[head++];
    var x=i%w,y=(i/w)|0;
    var p=i*4;
    d[p+3]=0;
    if(x>0)push(i-1);
    if(x<w-1)push(i+1);
    if(y>0)push(i-w);
    if(y<h-1)push(i+w);
  }
  ctx.putImageData(image,0,0);
}

function peCloseProductPreviewLightbox(){
  var modal=document.getElementById("uaPeProductPreviewLightbox");
  if(!modal)return;
  modal.classList.remove("is-open");
  modal.setAttribute("aria-hidden","true");
  document.documentElement.classList.remove("ua-pe-product-lightbox-open");
}

function pePositionProductLightboxArtwork(modal){
  if(!modal||!modal.classList.contains("is-open"))return;
  var data=modal._pePreviewData||{};
  var apparel=modal.querySelector("[data-pe-product-lightbox-apparel]");
  var artwork=modal.querySelector("[data-pe-product-lightbox-artwork]");
  var stage=modal.querySelector("[data-pe-product-lightbox-stage]");
  if(!apparel||!artwork||!stage||!data.artwork)return;

  var box=peActualContainedImageBox(apparel,stage);
  if(!box)return;

  /* V78: reduce garment zoom enough to keep the complete apparel silhouette
     inside the lightbox stage, with only a small upward bias. */
  var lightboxApparelZoom=1.14;
  var lightboxApparelLift=14;
  var boxCenterX=box.left+(box.width/2);
  var boxCenterY=box.top+(box.height/2);
  box.width*=lightboxApparelZoom;
  box.height*=lightboxApparelZoom;
  box.left=boxCenterX-(box.width/2);
  box.top=boxCenterY-(box.height/2)-lightboxApparelLift;

  var kind=data.kind||"top";
  var key=data.placement||peDefaultPlacement(data.artwork,kind);
  var spec=peProductPlacementSpec(kind,key);
  var itemScale=Math.max(.5,Math.min(2,(Number(data.artwork.scale)||100)/100));
  var adjustments=peEnsureLightboxAdjustments(modal);
  var manualScale=Math.max(.4,Math.min(2,Number(adjustments.sizePct||100)/100));

  var width=box.width*spec.w*itemScale*manualScale;
  var left=box.left+box.width*spec.x+Number(adjustments.x||0);
  var top=box.top+box.height*spec.y+Number(adjustments.y||0);

  artwork.style.setProperty("width",Math.max(28,width)+"px","important");
  artwork.style.setProperty("height","auto","important");
  artwork.style.setProperty("left",left+"px","important");
  artwork.style.setProperty("top",top+"px","important");
  artwork.style.setProperty("transform","translate(-50%,-50%) rotate("+Number(spec.rotate||0)+"deg)","important");
}

function peRenderProductPreviewLightbox(modal){
  var data=modal._pePreviewData||{};
  var title=modal.querySelector("[data-pe-product-lightbox-title]");
  var apparel=modal.querySelector("[data-pe-product-lightbox-apparel]");
  var artwork=modal.querySelector("[data-pe-product-lightbox-artwork]");
  var arts=modal.querySelector("[data-pe-product-lightbox-artworks]");
  var placements=modal.querySelector("[data-pe-product-lightbox-placements]");
  var removeUploadBtn=modal.querySelector("[data-pe-product-lightbox-remove-upload]");
  var openProduct=modal.querySelector("[data-pe-product-lightbox-open-product]");

  if(title)title.textContent=data.title||"Preview";

  if(apparel){
    apparel.src=s(data.apparelImage);
    apparel.alt=s(data.title||"PE apparel");
  }

  if(artwork&&data.artwork){
    artwork.src=s(data.artwork.image);
    artwork.alt=s(data.artwork.title||"Artwork sample");
  }

  if(arts){
    arts.innerHTML=(data.artworks||[]).map(function(item){
      var active=data.artwork&&s(item.id)===s(data.artwork.id);
      return '<button class="ua-pe-product-lightbox__artwork-option '+(active?"is-active":"")+'" type="button" data-pe-product-lightbox-artwork-id="'+esc(item.id)+'" aria-pressed="'+(active?"true":"false")+'" title="'+esc(item.title||"Artwork")+'">'+
        '<img src="'+esc(item.image)+'" alt="'+esc(item.title||"Artwork")+'">'+
      '</button>';
    }).join("");
  }

  if(placements){
    placements.innerHTML=pePlacementKeys(data.kind||"top").map(function(key){
      var active=s(key)===s(data.placement);
      return '<button class="ua-pe-product-lightbox__placement '+(active?"is-active":"")+'" type="button" data-pe-product-lightbox-placement="'+esc(key)+'" aria-pressed="'+(active?"true":"false")+'">'+esc(pePlacementLabel(key))+'</button>';
    }).join("");
  }

  if(removeUploadBtn){
    var hasCustomer=(data.artworks||[]).some(function(item){return !!item.customer;});
    removeUploadBtn.hidden=!hasCustomer;
    removeUploadBtn.disabled=!hasCustomer;
  }
  if(openProduct)openProduct.href=data.productUrl||'#';

  peSyncLightboxAdjustmentInputs(modal);
  peProductCartNote(modal,"Quantity and pricing will be completed in InkSoft Design Studio.",false);

  var rerender=function(){window.requestAnimationFrame(function(){pePositionProductLightboxArtwork(modal)});};
  if(apparel&&!apparel.complete)apparel.addEventListener("load",rerender,{once:true});
  if(artwork&&!artwork.complete)artwork.addEventListener("load",rerender,{once:true});
  rerender();
}

function peOpenProductPreviewLightbox(rootEl,card){
  if(!rootEl||!card)return;

  var artworks=peAvailableArtwork(rootEl,card);
  if(!artworks.length)return;

  var apparel=card.querySelector(".ua-pe-card__image");
  var modal=peEnsureProductPreviewLightbox();
  modal._peCustomerArtworkFile=null;
  var uploadInput=modal.querySelector("[data-pe-product-lightbox-upload]");
  var removeToggle=modal.querySelector("[data-pe-product-lightbox-remove-white]");
  if(uploadInput)uploadInput.value="";
  if(removeToggle)removeToggle.checked=false;
  peProductUploadNote(modal,"For best results, use a transparent PNG. Your image is processed only in this browser preview and is not saved.",false);
  var kind=s(card.dataset.peProductKind)||"top";
  var selected=artworks[0];

  var imageLink=card.querySelector(".ua-pe-card__image-link--previewable");
  var originalApparel=imageLink?s(imageLink.getAttribute("data-pe-product-apparel-original")):"";
  var liveApparel=apparel?s(apparel.currentSrc||apparel.src):"";
  var productIdValue=s(card.getAttribute("data-pe-product-id"));
  var styleIdValue=s(card.getAttribute("data-pe-product-style-id"));
  var productObj=PE_PRODUCTS_BY_ID.get(productIdValue)||null;
  var styleObj=peCurrentStyleForProduct(productObj,styleIdValue);
  modal._pePreviewData={
    title:(card.querySelector(".ua-pe-card__title")||{}).textContent||"PE Uniform Preview",
    apparelImage:originalApparel||preferOriginal(liveApparel)||liveApparel,
    kind:kind,
    artworks:artworks,
    artwork:selected,
    placement:peDefaultPlacement(selected,kind),
    adjustments:peDefaultLightboxAdjustments(),
    productUrl:s(card.getAttribute("data-pe-product-url")),
    productId:numVal(productIdValue),
    styleId:numVal(styleIdValue),
    selectedColor:s(card.getAttribute("data-pe-product-color")),
    productTags:peProductTags(productObj),
    cartEndpoint:s(rootEl.dataset.cartEndpoint)
  };

  modal.classList.add("is-open");
  modal.setAttribute("aria-hidden","false");
  document.documentElement.classList.add("ua-pe-product-lightbox-open");
  peRenderProductPreviewLightbox(modal);

  var closeBtn=modal.querySelector(".ua-pe-product-lightbox__close");
  if(closeBtn)closeBtn.focus({preventScroll:true});
}

function bindPeProductArtworkPreview(rootEl){
  if(!rootEl||rootEl.dataset.peProductPreviewBound==="true")return;
  rootEl.dataset.peProductPreviewBound="true";

  rootEl.addEventListener("click",function(ev){
    var toggle=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-preview-toggle]");
    if(toggle&&rootEl.contains(toggle)){
      ev.preventDefault();
      var card=toggle.closest(".ua-pe-card--product");
      if(!card)return;
      peOpenProductPreviewLightbox(rootEl,card);
      return;
    }

    var artBtn=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-preview-artwork-id]");
    if(artBtn&&rootEl.contains(artBtn)){
      ev.preventDefault();
      var artCard=artBtn.closest(".ua-pe-card--product");
      if(!artCard)return;
      var id=s(artBtn.getAttribute("data-pe-preview-artwork-id"));
      var item=peArtworkSamples(rootEl).find(function(x){return s(x.id)===id});
      if(item)peSetArtwork(rootEl,artCard,item,true);
      return;
    }

    var place=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-preview-placement]");
    if(place&&rootEl.contains(place)){
      ev.preventDefault();
      var placeCard=place.closest(".ua-pe-card--product");
      if(!placeCard)return;
      placeCard.dataset.pePreviewPlacementCurrent=s(place.getAttribute("data-pe-preview-placement"));
      if(!placeCard.classList.contains("is-pe-previewing"))peEnableProductPreview(rootEl,placeCard);
      peSyncPreviewControls(rootEl,placeCard);
      pePositionProductArtwork(rootEl,placeCard);
      return;
    }

    var remove=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-preview-remove]");
    if(remove&&rootEl.contains(remove)){
      ev.preventDefault();
      peDisableProductPreview(remove.closest(".ua-pe-card--product"));
    }
  });

  window.addEventListener("resize",function(){
    rootEl.querySelectorAll(".ua-pe-card--product.is-pe-previewing").forEach(function(card){
      window.requestAnimationFrame(function(){pePositionProductArtwork(rootEl,card)});
    });
  },{passive:true});
}

function peCategoryProductIds(category){
  return arr(
    category&&(
      category.productIds||
      category.ProductIds||
      category.products||
      category.Products
    )
  ).map(function(value){
    if(value&&typeof value==="object"){
      return s(value.id||value.productId||value.ProductId||value.ID);
    }
    return s(value);
  }).filter(Boolean);
}

function peCategoryMenuCandidates(parent,flat){
  var items=[];

  if(parent){
    items=children(parent).filter(function(category){
      return !!cid(category);
    });
  }

  if(!items.length){
    items=flat.filter(function(category){
      var name=cname(category);
      return (
        !!cid(category) &&
        !/^PE\s*Uniforms?$/i.test(name) &&
        /^(?:PE|P\.?\s*E\.?|Physical Education)\b/i.test(name)
      );
    });
  }

  /*
    Keep the menu apparel-specific. Nested technical/helper categories
    can still be returned by InkSoft, so prefer recognizable PE garment
    category names when available.
  */
  var preferred=items.filter(function(category){
    return /\b(?:shirt|tee|short|sweatshirt|sweatpant|pant|hoodie|jacket|uniform|jersey)\b/i.test(cname(category));
  });

  if(preferred.length)items=preferred;

  var seen=new Set();
  return items.filter(function(category){
    var id=cid(category);
    if(!id||seen.has(id))return false;
    seen.add(id);
    return true;
  }).sort(function(a,b){
    return cname(a).localeCompare(cname(b));
  });
}

function peMenuLabel(category){
  var name=cname(category);
  if(!name)return "PE Apparel";

  var clean=name
    .replace(/^Physical Education\s+/i,"")
    .replace(/^P\.?\s*E\.?\s+/i,"")
    .replace(/^PE\s+/i,"")
    .trim();

  if(!clean)return "PE Apparel";

  /* Requested storefront wording. */
  if(/^shorts?$/i.test(clean))return "PE Shorts";
  if(/^t[\s-]*shirts?$/i.test(clean))return "PE T-Shirt";

  return /^PE\b/i.test(clean)
    ? clean
    : "PE "+clean;
}

function peSetProductMenuActive(rootEl,button){
  rootEl.querySelectorAll(".ua-pe-product-menu__button").forEach(function(item){
    var active=item===button;
    item.classList.toggle("is-active",active);
    item.setAttribute("aria-pressed",active?"true":"false");
  });
}

async function peFetchProductsForCategory(rootEl,categoryId,pageSize){
  var purl=new URL(rootEl.dataset.productsEndpoint,location.origin);
  purl.searchParams.set("categoryId",categoryId);
  purl.searchParams.set("page","1");
  purl.searchParams.set("pageSize",String(pageSize||100));

  var furl=new URL(rootEl.dataset.productsFallback,location.origin);
  furl.searchParams.set("categoryId",categoryId);
  furl.searchParams.set("page","1");
  furl.searchParams.set("pageSize",String(pageSize||100));

  return products(await withFallback(purl.toString(),furl.toString()));
}

function peRenderProductSet(rootEl,list,statusText){
  var grid=rootEl.querySelector("[data-pe-products]");
  var status=rootEl.querySelector("[data-pe-products-status]");
  var empty=rootEl.querySelector("[data-pe-products-empty]");

  list=uniq(arr(list),pid);
  list.forEach(function(product){
    PE_PRODUCTS_BY_ID.set(pid(product),product);
  });

  grid.innerHTML=list.map(productCard).join("");
  grid.setAttribute("aria-busy","false");

  bindPeProductArtworkPreview(rootEl);

  status.textContent=statusText||
    (list.length
      ? list.length+(list.length===1?" PE product shown.":" PE products shown.")
      : "No PE products were returned.");

  empty.hidden=!!list.length;
}

function peBuildProductMenu(rootEl,parent,flat){
  var holder=rootEl.querySelector("[data-pe-product-menu-items]");
  if(!holder)return;

  /* Keep the two static buttons and replace only dynamic category items. */
  holder.querySelectorAll("[data-pe-product-menu-category]").forEach(function(button){
    button.remove();
  });

  peCategoryMenuCandidates(parent,flat).forEach(function(category){
    var button=document.createElement("button");
    button.type="button";
    button.className="ua-pe-product-menu__button";
    button.setAttribute("data-pe-product-menu-category","");
    button.setAttribute("data-pe-category-id",cid(category));
    button.setAttribute("aria-pressed","false");
    button.textContent=peMenuLabel(category);
    holder.appendChild(button);
  });
}


function peProductSearchText(product){
  var values=[
    s(product&&(
      product.name||
      product.title||
      product.productName||
      product.ProductName||
      product.Name
    )),
    pbrand(product),
    s(product&&(
      product.sku||
      product.SKU||
      product.styleNumber||
      product.StyleNumber||
      product.productCode||
      product.ProductCode
    ))
  ];

  return values
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

function peApplyProductSearch(rootEl,query){
  var q=s(query).trim().toLowerCase();

  if(!q){
    var allButton=rootEl.querySelector("[data-pe-product-menu-all]");
    if(allButton){
      peSetProductMenuActive(rootEl,allButton);
    }

    peRenderProductSet(
      rootEl,
      arr(rootEl._peAllProducts)
    );
    return;
  }

  var matches=arr(rootEl._peAllProducts).filter(function(product){
    return peProductSearchText(product).indexOf(q)!==-1;
  });

  /* Search is always PE-only and does not call the regular Product Catalog. */
  rootEl.querySelectorAll(".ua-pe-product-menu__button").forEach(function(button){
    button.classList.remove("is-active");
    button.setAttribute("aria-pressed","false");
  });

  peRenderProductSet(
    rootEl,
    matches,
    matches.length
      ? matches.length+(matches.length===1
          ?" PE product matched your search."
          :" PE products matched your search.")
      : 'No PE products matched "'+s(query).trim()+'".'
  );
}

function bindPeProductSearch(rootEl){
  if(!rootEl||rootEl.dataset.peProductSearchBound==="true")return;
  rootEl.dataset.peProductSearchBound="true";

  var form=rootEl.querySelector("[data-pe-product-search]");
  var input=rootEl.querySelector("[data-pe-product-search-input]");
  var clear=rootEl.querySelector("[data-pe-product-search-clear]");

  if(!form||!input)return;

  form.addEventListener("submit",function(ev){
    ev.preventDefault();
    peApplyProductSearch(rootEl,input.value);
  });

  input.addEventListener("input",function(){
    if(clear){
      clear.hidden=!s(input.value).trim();
    }
  });

  if(clear){
    clear.addEventListener("click",function(){
      input.value="";
      clear.hidden=true;
      peApplyProductSearch(rootEl,"");
      input.focus();
    });
  }
}

function bindPeProductMenu(rootEl){
  if(!rootEl||rootEl.dataset.peProductMenuBound==="true")return;
  rootEl.dataset.peProductMenuBound="true";

  rootEl.addEventListener("click",async function(ev){
    var viewAll=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-view-all]");
    if(viewAll&&document.contains(viewAll)){
      ev.preventDefault();
      var allButton=rootEl.querySelector("[data-pe-product-menu-all]");
      if(allButton){
        allButton.click();
        var menu=rootEl.querySelector("[data-pe-product-menu]");
        if(menu)menu.scrollIntoView({behavior:"smooth",block:"start"});
      }
      return;
    }

    var button=ev.target&&ev.target.closest&&ev.target.closest(".ua-pe-product-menu__button");
    if(!button||!rootEl.contains(button))return;

    ev.preventDefault();

    var grid=rootEl.querySelector("[data-pe-products]");
    var status=rootEl.querySelector("[data-pe-products-status]");

    peSetProductMenuActive(rootEl,button);

    var searchInput=rootEl.querySelector("[data-pe-product-search-input]");
    var searchClear=rootEl.querySelector("[data-pe-product-search-clear]");
    if(searchInput){
      searchInput.value="";
    }
    if(searchClear){
      searchClear.hidden=true;
    }

    if(button.hasAttribute("data-pe-product-menu-featured")){
      peRenderProductSet(
        rootEl,
        arr(rootEl._peFeaturedProducts),
        arr(rootEl._peFeaturedProducts).length+
          (arr(rootEl._peFeaturedProducts).length===1
            ?" featured PE product shown."
            :" featured PE products shown.")
      );
      return;
    }

    grid.setAttribute("aria-busy","true");
    status.textContent="Loading PE uniforms…";

    try{
      var list=[];

      if(button.hasAttribute("data-pe-product-menu-all")){
        list=arr(rootEl._peAllProducts);
      }else{
        var categoryId=s(button.getAttribute("data-pe-category-id"));
        list=await peFetchProductsForCategory(rootEl,categoryId,100);
      }

      peRenderProductSet(rootEl,list);
    }catch(error){
      console.error("[PE Program] PE product menu load failed",error);
      grid.setAttribute("aria-busy","false");
      status.textContent="PE products are temporarily unavailable.";
    }
  });
}

async function loadProducts(rootEl){
  var grid=rootEl.querySelector("[data-pe-products]");
  var status=rootEl.querySelector("[data-pe-products-status]");
  var empty=rootEl.querySelector("[data-pe-products-empty]");

  try{
    var catPayload=await withFallback(
      rootEl.dataset.categoriesEndpoint,
      rootEl.dataset.categoriesFallback
    );

    var flat=flatten(categories(catPayload));
    var parent=flat.find(function(category){
      return /^PE\s*Uniforms?$/i.test(cname(category));
    });

    var candidateIds=[];

    if(parent&&cid(parent)){
      candidateIds=[cid(parent)];
    }else{
      candidateIds=flat.filter(function(category){
        return /^(?:PE|P\.?\s*E\.?|Physical Education)\b/i.test(cname(category));
      }).map(cid).filter(Boolean);
    }

    candidateIds=Array.from(new Set(candidateIds));

    var all=[];

    for(var i=0;i<candidateIds.length;i++){
      try{
        all=all.concat(
          await peFetchProductsForCategory(
            rootEl,
            candidateIds[i],
            100
          )
        );
      }catch(_error){}
    }

    all=uniq(all,pid);

    var limit=Math.max(
      1,
      Number(rootEl.dataset.productsLimit||8)
    );

    rootEl._peAllProducts=all.slice();

    /*
     * V95 — INKSOFT-CONTROLLED PE FEATURED PRODUCTS
     * Add this Store Search Tag in InkSoft to any PE product that should
     * appear under the Featured tab:
     *
     *   featured_pe-uniform
     *
     * Matching is case-insensitive. When at least one tagged PE product is
     * found, Featured is built only from those tagged products. If no PE
     * products carry the tag, preserve the previous safe fallback and show
     * the first products from the PE catalog up to productsLimit.
     */
    var featuredTag="featured_pe-uniform";

    var taggedFeaturedProducts=all.filter(function(product){
      return peProductTags(product).some(function(tag){
        return s(tag).toLowerCase()===featuredTag;
      });
    });

    rootEl._peFeaturedProducts=taggedFeaturedProducts.length
      ? taggedFeaturedProducts
      : all.slice(0,limit);

    rootEl._peFeaturedSource=taggedFeaturedProducts.length
      ? "inksoft-tag"
      : "fallback-first-"+limit;

    console.info("[PE Program] Featured PE products resolved",{
      tag:featuredTag,
      source:rootEl._peFeaturedSource,
      taggedCount:taggedFeaturedProducts.length,
      featuredCount:rootEl._peFeaturedProducts.length
    });

    rootEl._peCategoryTree=flat;
    rootEl._peParentCategory=parent||null;

    peBuildProductMenu(rootEl,parent,flat);
    bindPeProductMenu(rootEl);
    bindPeProductSearch(rootEl);

    peRenderProductSet(
      rootEl,
      rootEl._peFeaturedProducts,
      rootEl._peFeaturedProducts.length+
        (rootEl._peFeaturedProducts.length===1
          ?" featured PE product shown."
          :" featured PE products shown.")
    );

    empty.hidden=!!rootEl._peFeaturedProducts.length;
  }catch(e){
    console.error("[PE Program] product load failed",e);
    grid.setAttribute("aria-busy","false");
    status.textContent="PE products are temporarily unavailable.";
    empty.hidden=false;
  }
}

function ensurePeDesignLightbox(){
  var existing=document.querySelector("[data-pe-design-lightbox-modal]");
  if(existing)return existing;

  var modal=document.createElement("div");
  modal.className="ua-pe-lightbox";
  modal.setAttribute("data-pe-design-lightbox-modal","");
  modal.setAttribute("aria-hidden","true");

  modal.innerHTML=
    '<div class="ua-pe-lightbox__backdrop" data-pe-lightbox-close></div>'+
    '<div class="ua-pe-lightbox__dialog" role="dialog" aria-modal="true" aria-labelledby="uaPeLightboxTitle">'+
      '<button class="ua-pe-lightbox__close" type="button" data-pe-lightbox-close aria-label="Close gallery">×</button>'+
      '<button class="ua-pe-lightbox__nav ua-pe-lightbox__nav--prev" type="button" data-pe-lightbox-prev aria-label="Previous design">‹</button>'+
      '<button class="ua-pe-lightbox__nav ua-pe-lightbox__nav--next" type="button" data-pe-lightbox-next aria-label="Next design">›</button>'+
      '<div class="ua-pe-lightbox__content">'+
        '<div class="ua-pe-lightbox__stage" data-pe-lightbox-stage></div>'+
        '<div class="ua-pe-lightbox__meta">'+
          '<h3 class="ua-pe-lightbox__title" id="uaPeLightboxTitle" data-pe-lightbox-title></h3>'+
          '<div class="ua-pe-lightbox__tools">'+
            '<button class="ua-pe-lightbox__enlarge" type="button" data-pe-lightbox-enlarge aria-pressed="false">Enlarge Image</button>'+
            '<div class="ua-pe-lightbox__counter" data-pe-lightbox-counter aria-live="polite"></div>'+
          '</div>'+
        '</div>'+
        '<div class="ua-pe-lightbox__thumbs" data-pe-lightbox-thumbs aria-label="Design gallery thumbnails"></div>'+
      '</div>'+
    '</div>';

  document.body.appendChild(modal);

  function close(){
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden","true");
    document.documentElement.classList.remove("ua-pe-lightbox-open");
    var stage=modal.querySelector("[data-pe-lightbox-stage]");
    if(stage)stage.innerHTML="";
    var opener=modal.__uaPeOpener;
    if(opener&&typeof opener.focus==="function")opener.focus();
    modal.__uaPeOpener=null;
    modal.__uaPeCards=[];
    modal.__uaPeIndex=0;
    modal.classList.remove("is-enlarged");
    var enlarge=modal.querySelector("[data-pe-lightbox-enlarge]");
    if(enlarge){
      enlarge.setAttribute("aria-pressed","false");
      enlarge.textContent="Enlarge Image";
    }
  }

  function move(delta){
    var cards=modal.__uaPeCards||[];
    if(cards.length<2)return;
    var next=(Number(modal.__uaPeIndex||0)+delta+cards.length)%cards.length;
    renderPeDesignLightboxCard(modal,next);
  }

  modal.querySelectorAll("[data-pe-lightbox-close]").forEach(function(el){
    el.addEventListener("click",close);
  });

  var prev=modal.querySelector("[data-pe-lightbox-prev]");
  var next=modal.querySelector("[data-pe-lightbox-next]");
  var enlarge=modal.querySelector("[data-pe-lightbox-enlarge]");
  if(prev)prev.addEventListener("click",function(){move(-1)});
  if(next)next.addEventListener("click",function(){move(1)});
  if(enlarge)enlarge.addEventListener("click",function(){
    var expanded=modal.classList.toggle("is-enlarged");
    enlarge.setAttribute("aria-pressed",expanded?"true":"false");
    enlarge.textContent=expanded?"Reduce Image":"Enlarge Image";
    window.requestAnimationFrame(function(){fitPeLightboxStage(modal)});
    schedulePeLightboxThumbRefit(modal);
  });

  document.addEventListener("keydown",function(ev){
    if(!modal.classList.contains("is-open"))return;
    if(ev.key==="Escape"){close();return}
    if(ev.key==="ArrowLeft"){ev.preventDefault();move(-1);return}
    if(ev.key==="ArrowRight"){ev.preventDefault();move(1)}
  });

  // Basic touch swipe support inside the image stage.
  var touchX=null;
  modal.addEventListener("touchstart",function(ev){
    var t=ev.touches&&ev.touches[0];
    touchX=t?t.clientX:null;
  },{passive:true});
  modal.addEventListener("touchend",function(ev){
    if(touchX===null)return;
    var t=ev.changedTouches&&ev.changedTouches[0];
    if(!t){touchX=null;return}
    var dx=t.clientX-touchX;
    touchX=null;
    if(Math.abs(dx)<45)return;
    move(dx>0?-1:1);
  },{passive:true});

  /*
    V51:
    Keep thumbnail positioning synchronized with any real modal/thumbnail-row
    resize. This is the programmatic equivalent of the layout correction that
    occurred when DevTools changed the viewport width.
  */
  if(typeof ResizeObserver!=="undefined"){
    var thumbHolder=modal.querySelector("[data-pe-lightbox-thumbs]");
    var thumbRO=new ResizeObserver(function(){
      if(!modal.classList.contains("is-open"))return;
      schedulePeLightboxThumbRefit(modal);
    });
    thumbRO.observe(modal);
    if(thumbHolder)thumbRO.observe(thumbHolder);
    modal.__uaPeThumbResizeObserver=thumbRO;
  }else{
    window.addEventListener("resize",function(){
      if(modal.classList.contains("is-open")){
        schedulePeLightboxThumbRefit(modal);
      }
    },{passive:true});
  }

  modal.__uaPeClose=close;
  modal.__uaPeMove=move;
  return modal;
}

function waitForPeLightboxImages(wrap){
  var imgs=Array.from(wrap.querySelectorAll("img"));
  if(!imgs.length)return Promise.resolve();
  return Promise.all(imgs.map(function(img){
    if(img.complete&&img.naturalWidth>0)return Promise.resolve();
    if(typeof img.decode==="function")return img.decode().catch(function(){});
    return new Promise(function(resolve){
      img.addEventListener("load",resolve,{once:true});
      img.addEventListener("error",resolve,{once:true});
    });
  })).then(function(){});
}

function fitPeLightboxStage(modal){
  if(!modal)return;
  var stage=modal.querySelector("[data-pe-lightbox-stage]");
  var wrap=stage&&stage.querySelector(".ua-pe-render--lightbox");
  if(!stage||!wrap)return;

  waitForPeLightboxImages(wrap).then(function(){
    if(!document.body.contains(wrap))return;

    /*
      Measure the real garment + artwork union at the original 348x372
      reference scale. Then center that union in the modal.

      CRITICAL V34 FIX:
      Previous CSS contained transform:... !important from V32.
      Therefore normal inline transform assignments could not win.
      V34 writes positioning/transform as inline !important.
    */
    wrap.style.setProperty("transform","none","important");
    wrap.style.setProperty("left","0px","important");
    wrap.style.setProperty("top","0px","important");
    wrap.style.setProperty("transform-origin","0 0","important");

    var base=wrap.getBoundingClientRect();
    var targets=Array.from(
      wrap.querySelectorAll(".ua-pe-render__apparel,.ua-pe-render__artwork")
    ).filter(function(el){
      var r=el&&el.getBoundingClientRect();
      return !!el&&el.getAttribute("src")&&r&&r.width>0&&r.height>0;
    });

    var minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
    targets.forEach(function(el){
      var r=el.getBoundingClientRect();
      minX=Math.min(minX,r.left-base.left);
      minY=Math.min(minY,r.top-base.top);
      maxX=Math.max(maxX,r.right-base.left);
      maxY=Math.max(maxY,r.bottom-base.top);
    });

    if(!isFinite(minX)||!isFinite(minY)||!isFinite(maxX)||!isFinite(maxY)){
      minX=0;minY=0;maxX=348;maxY=372;
    }

    var boundsW=Math.max(1,maxX-minX);
    var boundsH=Math.max(1,maxY-minY);

    /*
      V39:
      In normal lightbox mode keep comfortable padding and the existing
      restrained scale. In enlarged mode use almost the entire image stage
      and allow the garment to grow much larger while still fitting fully.
    */
    var enlarged=modal.classList.contains("is-enlarged");
    var padX=enlarged
      ? Math.max(12,Math.min(24,stage.clientWidth*.018))
      : Math.max(28,Math.min(52,stage.clientWidth*.055));
    var padY=enlarged
      ? Math.max(12,Math.min(22,stage.clientHeight*.018))
      : Math.max(24,Math.min(44,stage.clientHeight*.055));

    var availableW=Math.max(1,stage.clientWidth-(padX*2));
    var availableH=Math.max(1,stage.clientHeight-(padY*2));

    var scale=Math.min(availableW/boundsW,availableH/boundsH);

    /*
      V41:
      In enlarged mode do NOT cap the render scale. The computed fit scale is
      already the exact maximum that keeps the complete measured garment +
      artwork union inside the available lightbox stage.

      This fixes wide garments such as T-shirts remaining artificially small.
      Normal (non-enlarged) lightbox behavior remains capped at 1.65.
    */
    if(enlarged){
      scale=Math.max(.12,scale);

      /*
        V43:
        Many T-shirt source images contain substantially more built-in
        transparent/blank canvas around the garment than shorts or pants.
        The DOM image bounds therefore make a tee look smaller even when the
        image element itself has mathematically filled the stage.

        Give shirt/tee renders a visual-size correction in enlarged mode only.
        This does NOT change artwork placement relative to the apparel.
      */
      var apparelKind=s(wrap.dataset.apparelKind).toLowerCase();
      var isShirt=/\b(t[- ]?shirt|tee|shirt)\b/.test(apparelKind);
      var isShort=/\b(short|shorts)\b/.test(apparelKind);

      if(isShirt)scale*=1.20;
      if(isShort)scale*=0.94;
    }else{
      scale=Math.max(.12,Math.min(1.65,scale));
    }

    var centerX=(minX+maxX)/2;
    var centerY=(minY+maxY)/2;

    var tx=(stage.clientWidth/2)-(centerX*scale);
    var ty=(stage.clientHeight/2)-(centerY*scale);

    /*
      V44:
      Slightly raise T-shirts in enlarged mode so the neckline/sleeves sit
      higher in the available viewing area. Other garments remain untouched.
    */
    if(enlarged){
      if(typeof isShirt!=="undefined"&&isShirt){
        ty-=34;
      }else if(typeof isShort!=="undefined"&&isShort){
        ty-=22;
      }
    }

    wrap.style.setProperty("transform-origin","0 0","important");
    wrap.style.setProperty(
      "transform",
      "translate("+tx+"px,"+ty+"px) scale("+scale+")",
      "important"
    );

    wrap.dataset.lightboxFit="centered-actual-bounds-v34";
  });
}

function fitPeLightboxThumbRender(thumb){
  if(!thumb)return;
  var wrap=thumb.querySelector(".ua-pe-render--thumb");
  if(!wrap)return;

  waitForPeLightboxImages(wrap).then(function(){
    if(!document.body.contains(wrap))return;

    /*
      V47:
      Thumbnail fitting is now based primarily on the APPAREL silhouette,
      not the artwork union. The artwork is locked to the same composite and
      scales with the garment automatically.

      This gives every thumbnail a recognizable "whole garment" preview
      instead of the narrow strip/crop seen in V46.
    */
    wrap.style.setProperty("transform","none","important");
    wrap.style.setProperty("left","0px","important");
    wrap.style.setProperty("top","0px","important");
    wrap.style.setProperty("width","348px","important");
    wrap.style.setProperty("height","372px","important");
    wrap.style.setProperty("min-width","348px","important");
    wrap.style.setProperty("min-height","372px","important");
    wrap.style.setProperty("transform-origin","0 0","important");
    wrap.style.setProperty("overflow","visible","important");

    var innerStage=wrap.querySelector(".ua-pe-render__stage");
    if(innerStage){
      innerStage.style.setProperty("left","0px","important");
      innerStage.style.setProperty("top","0px","important");
      innerStage.style.setProperty("right","auto","important");
      innerStage.style.setProperty("bottom","auto","important");
      innerStage.style.setProperty("inset","auto","important");
      innerStage.style.setProperty("width","348px","important");
      innerStage.style.setProperty("height","372px","important");
      innerStage.style.setProperty("transform","none","important");
      innerStage.style.setProperty("transform-origin","0 0","important");
      innerStage.style.setProperty("overflow","visible","important");
    }

    var base=wrap.getBoundingClientRect();

    var apparel=wrap.querySelector(".ua-pe-render__apparel");
    var targets=[];
    if(apparel&&apparel.getAttribute("src")){
      var ar=apparel.getBoundingClientRect();
      if(ar.width>0&&ar.height>0)targets=[apparel];
    }

    // Fallback only if the apparel image itself cannot be measured.
    if(!targets.length){
      targets=Array.from(
        wrap.querySelectorAll(".ua-pe-render__apparel,.ua-pe-render__artwork")
      ).filter(function(el){
        var r=el&&el.getBoundingClientRect();
        return !!el&&el.getAttribute("src")&&r&&r.width>0&&r.height>0;
      });
    }

    var minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
    targets.forEach(function(el){
      var r=el.getBoundingClientRect();
      minX=Math.min(minX,r.left-base.left);
      minY=Math.min(minY,r.top-base.top);
      maxX=Math.max(maxX,r.right-base.left);
      maxY=Math.max(maxY,r.bottom-base.top);
    });

    if(!isFinite(minX)||!isFinite(minY)||!isFinite(maxX)||!isFinite(maxY)){
      minX=0;minY=0;maxX=348;maxY=372;
    }

    var boundsW=Math.max(1,maxX-minX);
    var boundsH=Math.max(1,maxY-minY);

    /*
      V50:
      Use a TRUE contain-fit for the thumbnail and deliberately keep a small
      safety margin. V48/V49 multiplied the already fitted scale by 1.08/1.04,
      which could push a garment back outside the tiny thumbnail viewport and
      make it look left/right shifted or cropped.

      No post-fit enlargement is used here.
    */
    var pad=4;
    var stage=thumb.querySelector(".ua-pe-lightbox__thumb-stage")||thumb;
    var availableW=Math.max(1,stage.clientWidth-(pad*2));
    var availableH=Math.max(1,stage.clientHeight-(pad*2));
    var scale=Math.min(availableW/boundsW,availableH/boundsH);

    /*
      Keep a tiny extra safety factor so garment edges do not visually touch
      the active thumbnail border.
    */
    scale*=0.96;

    var apparelKind=s(wrap.dataset.apparelKind).toLowerCase();
    var isShirt=/\b(t[- ]?shirt|tee|shirt)\b/.test(apparelKind);
    var isShort=/\b(short|shorts)\b/.test(apparelKind);

    var centerX=(minX+maxX)/2;
    var centerY=(minY+maxY)/2;

    /*
      V49:
      Center the visible apparel silhouette INSIDE the actual thumbnail stage.
      The previous V48 math used the correct scale but could still inherit a
      slight visual offset from the source render coordinates.

      Recalculate against the scaled apparel bounds, then apply a final
      centering correction so the garment lands in the visual middle of the
      thumbnail button.
    */
    var tx=(stage.clientWidth/2)-(centerX*scale);
    var ty=(stage.clientHeight/2)-(centerY*scale);

    var scaledLeft=minX*scale+tx;
    var scaledTop=minY*scale+ty;
    var scaledRight=maxX*scale+tx;
    var scaledBottom=maxY*scale+ty;

    var visibleCenterX=(scaledLeft+scaledRight)/2;
    var visibleCenterY=(scaledTop+scaledBottom)/2;

    tx+=(stage.clientWidth/2)-visibleCenterX;
    ty+=(stage.clientHeight/2)-visibleCenterY;

    /*
      V50: no optical X/Y bias. Keep the garment mathematically centered.
    */

    wrap.style.setProperty(
      "transform",
      "translate("+tx+"px,"+ty+"px) scale("+scale+")",
      "important"
    );

    wrap.dataset.thumbFit="true-contain-centered-v50";
  });
}


function refitPeLightboxThumbs(modal){
  if(!modal||!modal.classList.contains("is-open"))return;
  var holder=modal.querySelector("[data-pe-lightbox-thumbs]");
  if(!holder)return;

  holder.querySelectorAll("[data-pe-lightbox-thumb]").forEach(function(btn){
    fitPeLightboxThumbRender(btn);
  });
}

function schedulePeLightboxThumbRefit(modal){
  if(!modal)return;

  /*
    V51:
    The thumbnail row can finish its final layout AFTER the modal first opens.
    DevTools happened to fix the issue because opening DevTools forces a
    viewport/layout recalculation.

    Refit across multiple settled layout frames so we don't measure the
    thumbnail stage while it still has its pre-layout dimensions.
  */
  window.requestAnimationFrame(function(){
    window.requestAnimationFrame(function(){
      refitPeLightboxThumbs(modal);
    });
  });

  window.setTimeout(function(){
    refitPeLightboxThumbs(modal);
  },80);

  window.setTimeout(function(){
    refitPeLightboxThumbs(modal);
  },220);
}

function renderPeLightboxThumbs(modal){
  var cards=modal.__uaPeCards||[];
  var holder=modal.querySelector("[data-pe-lightbox-thumbs]");
  if(!holder)return;

  holder.innerHTML="";

  cards.forEach(function(card,i){
    var source=card.querySelector(".ua-pe-render");
    var fallback=card.querySelector(".ua-pe-card__image");
    var titleEl=card.querySelector(".ua-pe-card__title");
    var label=s(titleEl&&titleEl.textContent)||("Design "+(i+1));

    var btn=document.createElement("button");
    btn.type="button";
    btn.className="ua-pe-lightbox__thumb";
    btn.setAttribute("data-pe-lightbox-thumb",String(i));
    btn.setAttribute("aria-label","View "+label);

    var stage=document.createElement("span");
    stage.className="ua-pe-lightbox__thumb-stage";

    if(source){
      var clone=source.cloneNode(true);
      clone.classList.add("ua-pe-render--thumb");
      stage.appendChild(clone);

      clone.querySelectorAll("img").forEach(function(img){
        if(!img.complete){
          img.addEventListener("load",function(){
            fitPeLightboxThumbRender(btn);
          },{once:true});
        }
      });
    }else if(fallback){
      var image=fallback.cloneNode(true);
      image.classList.add("ua-pe-lightbox__thumb-fallback");
      image.removeAttribute("loading");
      stage.appendChild(image);
    }

    btn.appendChild(stage);
    btn.addEventListener("click",function(){
      renderPeDesignLightboxCard(modal,i);
    });

    holder.appendChild(btn);
  });

  schedulePeLightboxThumbRefit(modal);
}

function syncPeLightboxThumbState(modal,index){
  var holder=modal.querySelector("[data-pe-lightbox-thumbs]");
  if(!holder)return;
  holder.querySelectorAll("[data-pe-lightbox-thumb]").forEach(function(btn){
    var active=Number(btn.getAttribute("data-pe-lightbox-thumb"))===index;
    btn.classList.toggle("is-active",active);
    btn.setAttribute("aria-current",active?"true":"false");
    if(active&&typeof btn.scrollIntoView==="function"){
      btn.scrollIntoView({behavior:"smooth",block:"nearest",inline:"center"});
    }
  });
}

function renderPeDesignLightboxCard(modal,index){
  var cards=modal.__uaPeCards||[];
  if(!cards.length)return;

  index=Math.max(0,Math.min(cards.length-1,Number(index)||0));
  modal.__uaPeIndex=index;

  var card=cards[index];
  var source=card.querySelector(".ua-pe-render");
  var fallback=card.querySelector(".ua-pe-card__image");
  var stage=modal.querySelector("[data-pe-lightbox-stage]");
  var title=modal.querySelector("[data-pe-lightbox-title]");
  var counter=modal.querySelector("[data-pe-lightbox-counter]");
  var prev=modal.querySelector("[data-pe-lightbox-prev]");
  var next=modal.querySelector("[data-pe-lightbox-next]");
  if(!stage||!title)return;

  stage.innerHTML="";

  if(source){
    var clone=source.cloneNode(true);
    clone.classList.add("ua-pe-render--lightbox");
    stage.appendChild(clone);
  }else if(fallback){
    var image=fallback.cloneNode(true);
    image.classList.add("ua-pe-lightbox__fallback-image");
    image.removeAttribute("loading");
    stage.appendChild(image);
  }

  var cardTitle=card.querySelector(".ua-pe-card__title");
  title.textContent=s(cardTitle&&cardTitle.textContent)||"PE Uniform Design";
  if(counter)counter.textContent=(index+1)+" of "+cards.length;
  syncPeLightboxThumbState(modal,index);

  var multi=cards.length>1;
  if(prev)prev.hidden=!multi;
  if(next)next.hidden=!multi;

  window.requestAnimationFrame(function(){
    fitPeLightboxStage(modal);
  });
}

function openPeDesignLightbox(trigger){
  var card=trigger&&trigger.closest(".ua-pe-card");
  if(!card)return;

  var root=card.closest("[data-ua-pe-program]");
  var track=root&&root.querySelector("[data-pe-designs]");
  var cards=track?Array.from(track.querySelectorAll(".ua-pe-card")):[card];
  var index=Math.max(0,cards.indexOf(card));

  var modal=ensurePeDesignLightbox();
  modal.__uaPeCards=cards;
  modal.__uaPeIndex=index;
  modal.__uaPeOpener=trigger;

  modal.classList.add("is-open");
  modal.setAttribute("aria-hidden","false");
  document.documentElement.classList.add("ua-pe-lightbox-open");

  renderPeLightboxThumbs(modal);
  renderPeDesignLightboxCard(modal,index);

  schedulePeLightboxThumbRefit(modal);

  window.requestAnimationFrame(function(){
    var closeBtn=modal.querySelector(".ua-pe-lightbox__close");
    if(closeBtn)closeBtn.focus();
  });
}

function bindPeDesignLightbox(rootEl){
  if(!rootEl||rootEl.dataset.peLightboxBound==="true")return;
  rootEl.dataset.peLightboxBound="true";

  rootEl.addEventListener("click",function(ev){
    var trigger=ev.target&&ev.target.closest&&ev.target.closest("[data-pe-design-lightbox]");
    if(!trigger||!rootEl.contains(trigger))return;
    ev.preventDefault();
    openPeDesignLightbox(trigger);
  });
}

function peCarouselCardsPerView(){
  if(window.matchMedia&&window.matchMedia("(max-width: 639px)").matches)return 1;
  if(window.matchMedia&&window.matchMedia("(max-width: 989px)").matches)return 2;
  return 5;
}
function initPeDesignCarousel(rootEl){
  var carousel=rootEl.querySelector("[data-pe-design-carousel]");
  var viewport=rootEl.querySelector("[data-pe-design-viewport]");
  var track=rootEl.querySelector("[data-pe-designs]");
  var prev=rootEl.querySelector("[data-pe-design-prev]");
  var next=rootEl.querySelector("[data-pe-design-next]");
  if(!carousel||!viewport||!track||!prev||!next)return;

  function cards(){return Array.from(track.querySelectorAll(".ua-pe-card"))}
  function stepSize(){
    var list=cards();
    if(!list.length)return Math.max(1,viewport.clientWidth);
    var first=list[0];
    var second=list[1];
    if(second){
      return Math.max(1,second.offsetLeft-first.offsetLeft);
    }
    return Math.max(1,first.getBoundingClientRect().width);
  }
  function update(){
    var perView=peCarouselCardsPerView();
    var gap=parseFloat(getComputedStyle(carousel).getPropertyValue("--ua-pe-carousel-gap"))||14;
    var viewportWidth=Math.max(1,viewport.clientWidth);
    var cardWidth=Math.max(1,(viewportWidth-(gap*(perView-1)))/perView);
    carousel.style.setProperty("--ua-pe-carousel-card-width",cardWidth+"px");

    var max=Math.max(0,viewport.scrollWidth-viewport.clientWidth);
    var left=Math.max(0,viewport.scrollLeft);
    var overflow=max>3;
    prev.disabled=!overflow||left<=3;
    next.disabled=!overflow||left>=max-3;
    carousel.classList.toggle("ua-pe-design-carousel--static",!overflow);

    var count=cards().length;
    carousel.dataset.cardsPerView=String(perView);
    carousel.dataset.cardCount=String(count);
  }
  function move(dir){
    viewport.scrollBy({left:dir*stepSize()*peCarouselCardsPerView(),behavior:"smooth"});
  }

  prev.onclick=function(){move(-1)};
  next.onclick=function(){move(1)};
  viewport.addEventListener("scroll",function(){window.requestAnimationFrame(update)},{passive:true});
  window.addEventListener("resize",function(){window.requestAnimationFrame(function(){fitPeGridStages(rootEl);update()})},{passive:true});

  // Keyboard support when carousel viewport has focus.
  viewport.setAttribute("tabindex","0");
  viewport.setAttribute("role","region");
  viewport.setAttribute("aria-label","PE Uniform Design Ideas carousel");
  viewport.addEventListener("keydown",function(ev){
    if(ev.key==="ArrowLeft"){ev.preventDefault();move(-1)}
    if(ev.key==="ArrowRight"){ev.preventDefault();move(1)}
  });

  update();
}
async function loadDesigns(rootEl){
  var grid=rootEl.querySelector("[data-pe-designs]"),status=rootEl.querySelector("[data-pe-designs-status]"),empty=rootEl.querySelector("[data-pe-designs-empty]");
  try{
    var p=new URL(rootEl.dataset.designsEndpoint,location.origin);p.searchParams.set("take","250");
    var f=new URL(rootEl.dataset.designsFallback,location.origin);f.searchParams.set("take","250");
    var list=uniq(designItems(await withFallback(p.toString(),f.toString())).filter(isPE),function(d){return did(d)||dslug(d)});

    /*
      PE landing page merchandising rule:
      Always request at least 5 design examples when 5+ public PE designs exist.
      The section setting can raise the inventory up to 12.
    */
    var limit=Math.max(5,Number(rootEl.dataset.designsLimit||8));
    list=list.slice(0,limit);

    grid.innerHTML=list.map(designCard).join("");
    grid.setAttribute("aria-busy","false");
    fitPeGridStages(rootEl);
    initPeDesignCarousel(rootEl);
    bindPeDesignLightbox(rootEl);

    status.textContent=list.length
      ? list.length+(list.length===1?" PE design idea available.":" PE design ideas available.")
      : "No public PE design ideas were returned.";
    empty.hidden=!!list.length;
  }catch(e){
    console.error("[PE Program] design load failed",e);
    grid.setAttribute("aria-busy","false");
    status.textContent="PE design ideas are temporarily unavailable.";
    empty.hidden=false;
  }
}

window.addEventListener('resize',function(){
  var modal=document.querySelector('[data-pe-design-lightbox-modal].is-open');
  if(modal){
    fitPeLightboxStage(modal);
    modal.querySelectorAll('[data-pe-lightbox-thumb]').forEach(function(btn){
      fitPeLightboxThumbRender(btn);
    });
  }
},{passive:true});

function fitPeGridStages(rootEl){
  var wraps=Array.from(rootEl.querySelectorAll(".ua-pe-render"));
  wraps.forEach(function(wrap){
    var w=Math.max(1,wrap.clientWidth||1),h=Math.max(1,wrap.clientHeight||1);
    var scale=Math.min(w/348,h/372);
    wrap.style.setProperty("--ua-pe-grid-stage-scale",String(Math.max(.0001,scale)));
  });
}
function bindPeStageObserver(rootEl){
  if(typeof ResizeObserver!=="undefined"){
    var ro=new ResizeObserver(function(){fitPeGridStages(rootEl)});
    ro.observe(rootEl);
  }
  window.addEventListener("resize",function(){fitPeGridStages(rootEl)},{passive:true});
}

function movePeSupportSectionsLower(rootEl){
  /*
    ================================================================
    LIVE-SITE / PAGE-HIERARCHY GUARD — PE SUPPORT CONTENT
    The FAQ ("PE Uniform Questions") and related-links
    ("Explore more school apparel") remain unchanged functionally.
    This routine ONLY relocates their existing DOM blocks so the core
    shopping flow appears first:
      Products -> Design Ideas -> Custom Quote -> FAQ -> Related links
    Do not rewrite, clone, or rebuild the FAQ/related components here.
    ================================================================
  */
  try{
    var headings=Array.from(document.querySelectorAll("h1,h2,h3,h4,h5,h6"));
    var faqHeading=headings.find(function(h){return s(h.textContent)==="PE Uniform Questions"});
    var relatedHeading=headings.find(function(h){return s(h.textContent)==="Explore more school apparel"});
    if(!faqHeading&&!relatedHeading)return;

    function ownedBlock(heading){
      if(!heading)return null;
      var node=heading;
      while(node&&node.parentElement&&node.parentElement!==document.body){
        var parent=node.parentElement;
        var txt=s(parent.textContent);
        var parentHasShowcase=parent.contains(rootEl);
        if(parentHasShowcase)break;

        var looksLikeWholeSection=
          parent.matches("section,article") ||
          /faq|related|explore|questions/i.test(s(parent.className)) ||
          parent.querySelectorAll("h1,h2,h3,h4,h5,h6").length===1;

        if(looksLikeWholeSection){
          node=parent;
          if(parent.matches("section,article"))break;
        }else{
          break;
        }
      }
      return node;
    }

    var faqBlock=ownedBlock(faqHeading);
    var relatedBlock=ownedBlock(relatedHeading);

    // Avoid accidental movement of the entire shared landing-page section.
    [faqBlock,relatedBlock].forEach(function(block){
      if(!block)return;
      if(block===rootEl||block.contains(rootEl))throw new Error("Unsafe support block selection");
    });

    var insertionPoint=rootEl;
    var parent=rootEl.parentNode;
    if(!parent)return;

    if(faqBlock&&faqBlock.parentNode){
      parent.insertBefore(faqBlock,insertionPoint.nextSibling);
      insertionPoint=faqBlock;
      faqBlock.dataset.peSupportMoved="faq";
    }
    if(relatedBlock&&relatedBlock.parentNode){
      parent.insertBefore(relatedBlock,insertionPoint.nextSibling);
      relatedBlock.dataset.peSupportMoved="related";
    }

    rootEl.dataset.supportSectionsLowered="true";
  }catch(e){
    console.warn("[PE Program] Unable to move FAQ/related support sections lower.",e);
  }
}

function findHeadingByExactText(texts){
  var wanted=arr(texts).map(function(x){return s(x)});
  return Array.from(document.querySelectorAll("h1,h2,h3,h4,h5,h6")).find(function(h){
    return wanted.indexOf(s(h.textContent))>=0;
  })||null;
}
function ancestorsUntilBody(el){
  var out=[];
  while(el&&el!==document.body){out.push(el);el=el.parentElement}
  return out;
}
function lowestCommonAncestor(a,b){
  if(!a||!b)return null;
  var aa=ancestorsUntilBody(a),bb=ancestorsUntilBody(b);
  for(var i=0;i<aa.length;i++){if(bb.indexOf(aa[i])>=0)return aa[i]}
  return null;
}
function removeRedundantPeSupportBlock(rootEl){
  /*
    ================================================================
    LIVE-SITE / CONTENT-HIERARCHY GUARD — PE REDUNDANT COPY
    The hero now contains the core program value proposition and the
    dedicated PE Design Ideas section provides the actual preview.
    Therefore the old two-column:
      "PE Uniform Program Support"
      "Preview PE designs on apparel"
    block is intentionally removed on THIS PE page only.

    Do not remove or modify the shared unisource-seo-category-landing
    section globally. This DOM operation is scoped to /pages/pe-uniforms.
    ================================================================
  */
  try{
    var support=findHeadingByExactText([
      "PE Uniform Program Support",
      "PE Uniform Programs Built for Schools"
    ]);
    var preview=findHeadingByExactText([
      "Preview PE designs on apparel",
      "See PE uniform ideas on apparel"
    ]);
    if(!support&&!preview)return null;

    var common=lowestCommonAncestor(support,preview);
    var hero=findHeadingByExactText(["Custom PE Uniforms for Schools"]);
    var faq=findHeadingByExactText(["PE Uniform Questions"]);

    // Prefer the safe two-column wrapper when it does not contain hero/FAQ/showcase.
    if(common &&
       common!==document.body &&
       !common.contains(rootEl) &&
       !(hero&&common.contains(hero)) &&
       !(faq&&common.contains(faq))){
      common.dataset.peRedundantContent="removed";
      common.hidden=true;
      return common;
    }

    // Conservative fallback: hide only each individual content card.
    [support,preview].forEach(function(heading){
      if(!heading)return;
      var node=heading;
      while(node.parentElement &&
            node.parentElement!==document.body &&
            !(common&&node.parentElement===common)){
        var p=node.parentElement;
        if(p.contains(rootEl))break;
        node=p;
      }
      if(node&&node!==document.body&&!node.contains(rootEl)){
        node.dataset.peRedundantContent="removed-card";
        node.hidden=true;
      }
    });
    return common;
  }catch(e){
    console.warn("[PE Program] Unable to remove redundant PE support content.",e);
    return null;
  }
}
function removePeRedundantSupportContentHard(rootEl){
  /*
    ================================================================
    CRITICAL PE CONTENT GUARD — REMOVE ENTIRE REDUNDANT ROW
    Remove the COMPLETE two-column content holder containing:
      - PE Uniform Program Support
      - Preview PE designs on apparel

    Important:
    - Do not blank the fields and leave empty cards behind.
    - Do not move FAQ / Explore More out of their shared section.
    - Scope is only this PE landing page.
    ================================================================
  */
  try{
    var headings=Array.from(document.querySelectorAll("h1,h2,h3,h4,h5,h6"));
    var support=headings.find(function(h){
      var t=s(h.textContent);
      return t==="PE Uniform Program Support" || t==="PE Uniform Programs Built for Schools";
    });
    var preview=headings.find(function(h){
      var t=s(h.textContent);
      return t==="Preview PE designs on apparel" || t==="See PE uniform ideas on apparel";
    });
    if(!support && !preview)return;

    function chain(el){
      var out=[];
      while(el && el!==document.body){
        if(el===rootEl || el.contains(rootEl))break;
        out.push(el);
        el=el.parentElement;
      }
      return out;
    }

    // Best case: remove the smallest shared ancestor containing BOTH cards.
    if(support && preview){
      var a=chain(support), b=chain(preview), common=null;
      for(var i=0;i<a.length;i++){
        if(b.indexOf(a[i])>=0){common=a[i];break}
      }

      if(common &&
         common!==document.body &&
         common!==rootEl &&
         !common.contains(rootEl)){

        // The correct holder normally contains only these two content columns.
        var allHeadings=Array.from(common.querySelectorAll("h1,h2,h3,h4,h5,h6"))
          .map(function(h){return s(h.textContent)})
          .filter(Boolean);

        var allowed=allHeadings.every(function(t){
          return t==="PE Uniform Program Support" ||
                 t==="PE Uniform Programs Built for Schools" ||
                 t==="Preview PE designs on apparel" ||
                 t==="See PE uniform ideas on apparel";
        });

        if(allowed){
          common.remove();
          return;
        }
      }
    }

    // Fallback: remove each complete card individually without touching FAQ/related.
    [support,preview].forEach(function(heading){
      if(!heading)return;
      var el=heading;
      while(el && el.parentElement && el.parentElement!==document.body){
        var parent=el.parentElement;
        if(parent===rootEl || parent.contains(rootEl))break;

        var headingCount=parent.querySelectorAll("h1,h2,h3,h4,h5,h6").length;
        el=parent;

        // Stop at the first card-like wrapper containing just this heading.
        if(headingCount===1 &&
           (parent.matches("section,article") ||
            /card|panel|aside|content/i.test(s(parent.className)))) break;
      }
      if(el && el!==rootEl && !el.contains(rootEl))el.remove();
    });
  }catch(e){
    console.warn("[PE Program] Unable to remove redundant PE content row.",e);
  }
}

function peAssetUrl(filename){
  /*
    Resolve a sibling theme asset from this PE showcase JS asset URL.
    This avoids hardcoding a CDN host and keeps the hero image cache-safe.
  */
  try{
    var scripts=Array.from(document.scripts||[]);
    var current=document.currentScript||
      scripts.find(function(el){return /unisource-pe-program-showcase\.js(?:\?|$)/i.test(s(el.src))});
    var src=s(current&&current.src);
    if(!src)return "";
    var u=new URL(src,location.href);
    u.pathname=u.pathname.replace(/unisource-pe-program-showcase\.js$/i,filename);
    u.search="";
    return u.toString();
  }catch(_e){return ""}
}
function findPeHero(){
  var heading=findHeadingByExactText(["Custom PE Uniforms for Schools"]);
  if(!heading)return null;

  var node=heading;
  var best=null;

  while(node && node.parentElement && node.parentElement!==document.body){
    var parent=node.parentElement;
    var rect=parent.getBoundingClientRect();
    var style=getComputedStyle(parent);
    var radius=parseFloat(style.borderTopLeftRadius)||0;
    var links=Array.from(parent.querySelectorAll("a,button"))
      .map(function(el){return s(el.textContent)});

    var hasPrimary=links.some(function(t){return t==="Shop PE Uniforms"});
    var hasSecondary=links.some(function(t){return t==="Browse PE Design Ideas"});

    if(hasPrimary && hasSecondary && rect.width>=650 && rect.height>=260){
      best=parent;

      // Prefer the rounded/colored wrapper rather than an inner text column.
      var bg=style.backgroundImage!=="none" ||
             (style.backgroundColor && style.backgroundColor!=="rgba(0, 0, 0, 0)" &&
              style.backgroundColor!=="transparent");
      if(radius>=12 || bg)break;
    }
    node=parent;
  }
  return best;
}
function tagPeHeroContentWrapper(hero){
  /*
    V24: resolve the REAL nested hero copy chain.

    The shared SEO landing markup applies narrow sizing at multiple nested
    levels, so widening only one wrapper is insufficient. We therefore:
    1) find the heading,
    2) identify the content branch that also contains the hero CTAs,
    3) mark EVERY ancestor in that branch up to (but not including) the hero,
    4) normalize inherited width/flex/grid constraints on that chain.
  */
  try{
    if(!hero)return null;

    var heading=findHeadingByExactText(["Custom PE Uniforms for Schools"]);
    if(!heading || !hero.contains(heading))return null;

    var node=heading;
    var branch=[];
    var contentRoot=null;

    while(node && node.parentElement && node.parentElement!==hero){
      node=node.parentElement;
      branch.push(node);

      var links=Array.from(node.querySelectorAll("a,button"))
        .map(function(el){return s(el.textContent)});
      var hasShop=links.some(function(t){return t==="Shop PE Uniforms"});
      var hasIdeas=links.some(function(t){return t==="Browse PE Design Ideas"});
      var hasCopy=!!node.querySelector("p");

      if(hasCopy && (hasShop || hasIdeas)){
        contentRoot=node;
      }
    }

    if(!contentRoot){
      contentRoot=branch[branch.length-1]||heading.parentElement;
    }

    hero.querySelectorAll(".ua-pe-hero-copy-chain,.ua-pe-hero-content-live").forEach(function(el){
      el.classList.remove("ua-pe-hero-copy-chain","ua-pe-hero-content-live");
    });

    var current=heading.parentElement;
    while(current && current!==hero){
      current.classList.add("ua-pe-hero-copy-chain");

      // Inline normalization wins over shared CSS that may use fixed/flex widths.
      current.style.setProperty("max-width","none","important");
      current.style.setProperty("min-width","0","important");
      current.style.setProperty("box-sizing","border-box","important");

      if(current===contentRoot){
        current.classList.add("ua-pe-hero-content-live");
        current.style.setProperty("width","90%","important");
        current.style.setProperty("max-width","100%","important");
        current.style.setProperty("flex","0 0 48%","important");
        current.style.setProperty("flex-basis","48%","important");
        current.style.setProperty("grid-column","auto","important");
        current.style.setProperty("box-sizing","border-box","important");
        current.style.setProperty("min-width","0","important");
      }else{
        current.style.setProperty("width","100%","important");
      }

      current=current.parentElement;
    }

    // Also normalize the live text nodes themselves.
    [heading].concat(Array.from(contentRoot.querySelectorAll("p"))).forEach(function(el){
      if(!el)return;
      el.style.setProperty("width","100%","important");
      el.style.setProperty("max-width","100%","important");
    });

    contentRoot.dataset.peHeroContent="live-v24";
    return contentRoot;
  }catch(e){
    console.warn("[PE Program] Unable to normalize PE hero content chain.",e);
    return null;
  }
}

function applyPeHeroImage(rootEl){
  /*
    ================================================================
    CRITICAL PE HERO VISUAL GUARD
    PE-page-only visual enhancement.

    - Keeps the existing live hero headline, body copy and CTAs.
    - Adds a decorative apparel/student visual on the right.
    - Does NOT replace hero text with an image.
    - Does NOT alter Product Catalog, Design Inspiration, RFQ,
      pricing, cart/session/cookie, or backend behavior.
    ================================================================
  */
  try{
    var hero=findPeHero();
    if(!hero || hero.querySelector(".ua-pe-hero-visual"))return;

    hero.classList.add("ua-pe-hero--with-apparel-visual");
    tagPeHeroContentWrapper(hero);

    var visual=document.createElement("div");
    visual.className="ua-pe-hero-visual";
    visual.setAttribute("aria-hidden","true");

    var picture=document.createElement("picture");
    var webp=document.createElement("source");
    webp.type="image/webp";
    webp.srcset=peAssetUrl("unisource-pe-hero-students.webp");

    var image=document.createElement("img");
    image.src=peAssetUrl("unisource-pe-hero-students.png");
    image.alt="";
    image.loading="eager";
    image.decoding="async";
    image.fetchPriority="high";

    picture.appendChild(webp);
    picture.appendChild(image);
    visual.appendChild(picture);
    hero.appendChild(visual);
    tagPeHeroContentWrapper(hero);

    // Shared theme layout scripts may re-apply widths after initial render.
    window.setTimeout(function(){tagPeHeroContentWrapper(hero)},60);
    window.setTimeout(function(){tagPeHeroContentWrapper(hero)},350);

    hero.dataset.peHeroVisual="students-apparel-v1";
  }catch(e){
    console.warn("[PE Program] Unable to apply PE hero visual.",e);
  }
}

function widenPeUpperLanding(rootEl){
  /*
    ================================================================
    PE PAGE WIDTH GUARD — SHARED SEO LANDING SECTION
    The hero + four feature cards belong to the shared
    unisource-seo-category-landing section, not to the isolated
    PE showcase section. Previous width changes only affected the
    lower PE showcase.

    This function identifies the common wrapper containing:
      - "Custom PE Uniforms for Schools"
      - "Coordinated PE Sets"
    and applies a PE-page-only width class to that wrapper.

    Do NOT modify the shared section globally.
    ================================================================
  */
  try{
    var hero=findHeadingByExactText(["Custom PE Uniforms for Schools"]);
    var feature=findHeadingByExactText(["Coordinated PE Sets"]);
    if(!hero||!feature)return;

    var common=lowestCommonAncestor(hero,feature);
    if(!common||common===document.body||common.contains(rootEl))return;

    /*
      The first common ancestor can occasionally be an inner layout wrapper.
      Prefer the nearest centered page wrapper that still contains both areas,
      but stop before BODY/main theme shells.
    */
    var candidate=common;
    var node=common;
    while(node&&node.parentElement&&node.parentElement!==document.body){
      var parent=node.parentElement;
      if(parent.contains(rootEl))break;
      if(!parent.contains(hero)||!parent.contains(feature))break;

      var rect=parent.getBoundingClientRect();
      var childRect=node.getBoundingClientRect();

      // Move one level up only when it still behaves like the same bounded
      // landing-page container rather than a full-width theme shell.
      if(rect.width>0 &&
         rect.width < Math.min(window.innerWidth*0.94, 1500) &&
         rect.width <= childRect.width + 80){
        candidate=parent;
        node=parent;
      }else{
        break;
      }
    }

    candidate.classList.add("ua-pe-upper-wide");
    candidate.dataset.peUpperWide="true";
  }catch(e){
    console.warn("[PE Program] Unable to widen upper PE landing content.",e);
  }
}


function updatePeCustomerFacingCopy(){
  /*
    ================================================================
    V92 COPY-ONLY UPDATE
    Text changes only. No pricing, artwork, Design Studio, product,
    cart, session, placement, or backend behavior is changed.
    ================================================================
  */
  try{
    var oldHeading=findHeadingByExactText([
      "Need a Different PE Uniform Program?"
    ]);

    if(oldHeading){
      oldHeading.textContent="Looking for a Different PE Apparel Option?";
    }
  }catch(e){
    console.warn("[PE Program] Unable to update PE customer-facing copy.",e);
  }
}

function moveShowcaseUp(rootEl){
  /*
    ================================================================
    LIVE-SITE / PAGE-HIERARCHY GUARD — PE CORE COMMERCE
    Products and Design Inspiration are primary PE landing-page content,
    not an appendix. Move the isolated PE showcase directly after the
    four PE feature cards and before the redundant long-form support block.

    This operation does NOT alter Product Catalog, Product Detail,
    pricing, cart/session/cookie, or backend behavior.
    ================================================================
  */
  try{
    var support=findHeadingByExactText([
      "PE Uniform Program Support",
      "PE Uniform Programs Built for Schools"
    ]);
    var preview=findHeadingByExactText([
      "Preview PE designs on apparel",
      "See PE uniform ideas on apparel"
    ]);
    var anchor=lowestCommonAncestor(support,preview);

    if(!anchor && support){
      anchor=support.closest("section,article")||support.parentElement;
    }
    if(!anchor)return;

    var hero=findHeadingByExactText(["Custom PE Uniforms for Schools"]);
    var faq=findHeadingByExactText(["PE Uniform Questions"]);

    // Never relocate against an ancestor that is effectively the entire shared section.
    if(anchor.contains(rootEl) ||
       (hero&&anchor.contains(hero)) ||
       (faq&&anchor.contains(faq))){
      var supportCard=support&&(support.closest("section,article")||support.parentElement);
      if(supportCard &&
         !supportCard.contains(rootEl) &&
         !(hero&&supportCard.contains(hero)) &&
         !(faq&&supportCard.contains(faq))){
        anchor=supportCard;
      }else{
        return;
      }
    }

    if(anchor.parentNode && rootEl!==anchor && rootEl.nextSibling!==anchor){
      anchor.parentNode.insertBefore(rootEl,anchor);
      rootEl.dataset.promotedCoreContent="true";
    }

    removeRedundantPeSupportBlock(rootEl);
  }catch(e){
    console.warn("[PE Program] Unable to promote PE commerce content.",e);
  }
}

updatePeCustomerFacingCopy();

roots.forEach(function(rootEl){
  widenPeUpperLanding(rootEl);
  applyPeHeroImage(rootEl);
  moveShowcaseUp(rootEl);

  /*
    FAQ / Explore More remain in their original shared-section DOM so
    their existing styling is preserved. Once the redundant support row
    is removed, they naturally follow the PE showcase.
  */

  // Remove the redundant support row after the PE showcase is promoted.
  removePeRedundantSupportContentHard(rootEl);
  window.setTimeout(function(){removePeRedundantSupportContentHard(rootEl)},50);
  window.setTimeout(function(){removePeRedundantSupportContentHard(rootEl)},400);

  bindPeStageObserver(rootEl);
  loadProducts(rootEl);
  loadDesignMatrix().finally(function(){loadDesigns(rootEl)});
});
})();